<!--语智网-语智星语言分析器-->
<template>
  <div id="app">	
	<img src="../static/logo_head1.jpg" class="logo-img" width="500"  @click="handleLogoClick" alt="logo"/> <br>

   	<label for="label" @change="click_check_show_template">
		<input type="checkbox" id="labe20" v-model="check_show_template" value="true">显示模板 
	</label>&nbsp
 	<label for="label" @change="click_check_show_number">
		<input type="checkbox" id="label1" v-model="check_show_number" value="true">编号
	</label>
  	 <label for="label" @change="click_check_show_word">
		<input type="checkbox" id="label2" v-model="check_show_word" value="true">词
	</label>
  	 <label for="label" @change="click_check_show_pos">
		<input type="checkbox" id="label3" v-model="check_show_pos" value="true">词性
	</label>
  	 <label for="label" @change="click_check_show_sense">
		<input type="checkbox" id="label4" v-model="check_show_sense" value="true">词义
	</label>
  	 <label for="label" @change="click_check_show_entity">
		<input type="checkbox" id="label5" v-model="check_show_entity" value="true">命名实体
	</label>
  	 <label for="label" @change="click_check_show_head">
		<input type="checkbox" id="label6" v-model="check_show_head" value="true">中心词
	</label>
  	 <label for="label" @change="click_check_show_relation_count">
		<input type="checkbox" id="label7" v-model="check_show_relation_count" value="true">关联度
	</label>
	</label>
  	 <label for="label" @change="click_check_show_link">
		<input type="checkbox" id="label8" v-model="check_show_link" value="true">语义关联
	</label>
	 
	<input type="button"  @click="revise_cutting_word" value="分词校对" /> &nbsp &nbsp
	库名：
	<textarea type="textarea"  style="font-size:14px" cols="15" rows="1" v-model="bank_name" ></textarea>
	区名：
	<textarea type="textarea"  style="font-size:14px" cols="15" rows="1" v-model="section_name" ></textarea> &nbsp &nbsp
	用户：
	<textarea type="textarea"  style="font-size:14px" cols="10" rows="1" v-model="user_name" ></textarea>
	密码：
	<input ref="passWord" type="password" autocomplete="new-password" readonly onfocus="this.removeAttribute('readonly');this.type='password'" placeholder="*****" v-model="passWord" v-show="!showPass"/>

 	<input type="button"  @click="login" value="登录" />&nbsp &nbsp
  	<label for="label" @change="click_check_show_template">
		<input type="checkbox" id="labe21" v-model="check_romote_port" value="true">远程访问 
	</label>&nbsp
	<br> 
	编辑限定：
	<span ref="edited_result" v-bind:style="edited_result_style">{{edited_result}} </span>&nbsp
	规则限定：
	<span ref="ruled_result" v-bind:style="ruled_result_style">{{ruled_result}} </span>&nbsp
	区内句子编号：
	<textarea type="textarea"  style="font-size:14px" cols="10" rows="1" v-model="sentence_number_of_template" ></textarea>
  	<input type="button"  @click="jump_now_sentence_number_of_template" value="Go" />
  	<input type="button"  @click="jump_last_sentence_number_of_template" value="<" />
  	<input type="button"  @click="jump_next_sentence_number_of_template" value=">" />
	&nbsp
	Rank编号：
	<textarea type="textarea"  style="font-size:14px" cols="8" rows="1" v-model="template_number_on_rank" ></textarea>
  	<input type="button"  @click="jump_now_rank_template" value="GO" />
  	<input type="button"  @click="jump_last_rank_template" value="<" />
  	<input type="button"  @click="jump_next_rank_template" value=">" /> &nbsp
    得分：
	<span ref="match_score" v-bind:style="match_score_style">{{match_score}} </span>&nbsp
    模板ID：
	<span ref="matched_template_id" v-bind:style="matched_template_id_style">{{matched_template_id}} </span>&nbsp
	句库句子编号：
	<textarea type="textarea"  style="font-size:14px" cols="10" rows="1" v-model="sentence_number_in_sentencebank" ></textarea>
  	<input type="button"  @click="jump_now_sentence_number_in_sentencebank" value="GO" />
  	<input type="button"  @click="jump_last_sentence_number_in_sentencebank" value="<" />
  	<input type="button"  @click="jump_next_sentence_number_in_sentencebank" value=">" /> &nbsp
 	<input type="button"  @click="parse_all_sentence" value="全库分析" /> &nbsp
	FAQ句子编号：
	<textarea type="textarea"  style="font-size:14px" cols="10" rows="1" v-model="sentence_number_in_faqbank" ></textarea>
  	<input type="button"  @click="jump_now_sentence_number_in_faqbank" value="GO" />
  	<input type="button"  @click="jump_last_sentence_number_in_faqbank" value="<" />
  	<input type="button"  @click="jump_next_sentence_number_in_faqbank" value=">" /> &nbsp
	操作：
	<textarea type="textarea"  style="font-size:14px" cols="8" rows="1" v-model="run_operation" ></textarea>&nbsp  
	<input type="button"  @click="learn_template" value="模板学习" /> &nbsp &nbsp    
	<input type="button"  @click="learn_tongyici" value="同义词学习" /> &nbsp &nbsp   
<!--	<input type="button"  @click="create_bank_section" value="新建库区" /> &nbsp &nbsp   --> 
<!--	<input type="button"  @click="change_password" value="修改密码" />  &nbsp &nbsp   -->   
<!--	<input type="button"  @click="set_semanticcode_matchLength" value="匹配设置" />  &nbsp &nbsp  -->
<!--	<input type="button"  @click="set_user_ip_duration" value="用户IP" />   -->
<!--		<input type="button"  @click="phone_verified_code" value="手机验证码" />&nbsp &nbsp   -->
<!--		<input type="button"  @click="register" value="注册" />&nbsp &nbsp   -->
	<input type="button"  @click="get_faq" value="FAQ回应" /> 
	<input type="button"  @click="send_faq" value="上传FAQ" />  
	微信编号：
	<textarea type="textarea"  style="font-size:14px" cols="15" rows="1" v-model="weixin_number" ></textarea>
	<input type="button"  @click="remote_send_faq" value="远程上传FAQ" /> 
	<br> 
	输入句子：
	<textarea type="textarea"  style="font-size:14px" cols="140" rows="1" v-model="input_sentence" ></textarea>
  	<input type="button"  @click="parse_sentence" value="分析" />&nbsp &nbsp &nbsp &nbsp &nbsp &nbsp
	<button v-show="showButton_send_message" @click="send_message">发送消息</button> &nbsp &nbsp 

    <br> 
	UR编号：
	<textarea type="textarea"  style="font-size:14px" cols="8" rows="1" v-model="ur_number_in_document" ></textarea>
   	<input type="button"  @click="jump_now_ur_number_in_document" value="GO" />
 	<input type="button"  @click="jump_last_ur_number_in_document" value="<" />
  	<input type="button"  @click="jump_next_ur_number_in_document" value=">" /> &nbsp
<!--	<input type="button"  @click="jump_specified_ur_number_in_document" value="查找" />  -->
	<button v-show="showButton_get_user_expired_time" @click="get_user_expired_time">查看使用期限</button> &nbsp &nbsp 
	<button v-show="showButton_admin_user_using_time" @click="admin_user_using_time">设置使用期限</button> &nbsp &nbsp
	<button v-show="showButton_update_resource_parameter" @click="update_resource_parameter">更新资源参数</button> &nbsp &nbsp 
	资源编号：
	<textarea type="textarea"  style="font-size:14px" cols="8" rows="1" v-model="resource_number_in_document" ></textarea>
   	<input type="button"  @click="jump_now_resource_number_in_document" value="GO" />
 	<input type="button"  @click="jump_last_resource_number_in_document" value="<" />
  	<input type="button"  @click="jump_next_resource_number_in_document" value=">" /> &nbsp
	<button v-show="showButton_update_resource_access_code" @click="update_resource_access_code">更新资源</button> &nbsp &nbsp   
	<button v-show="showButton_watch_resource_access_code" @click="watch_resource_access_code">JX资源</button> &nbsp &nbsp 
	<button v-show="showButton_add_resource_access_code" @click="add_resource_access_code">增加资源</button> &nbsp &nbsp 
	
    <br> 
	FAQ句：
	<textarea type="textarea"  style="font-size:14px" cols="40" rows="1" v-model="faq_question" ></textarea>
	回答：
	<textarea type="textarea"  style="font-size:14px" cols="30" rows="1" v-model="faq_answer" ></textarea>
	动作：
	<textarea type="textarea"  style="font-size:14px" cols="20" rows="1" v-model="faq_action" ></textarea>
	意图：
	<textarea type="textarea"  style="font-size:14px" cols="20" rows="1" v-model="faq_meaning" ></textarea>
	<button v-show="showButton_create_active_code" @click="create_active_code">生成</button> &nbsp &nbsp 
	<br> 
 	机器分析：
	<textarea type="textarea"  style="font-size:14px" cols="140" rows="2" v-model="output_understanding" ></textarea>   	
	<label for="label" @change="click_check_simply_show">
		<input type="checkbox" id="label22" v-model="check_simply_show" value="true">简化显示 
	</label>&nbsp
	<br> 
    输出结果：
	<textarea type="textarea"  style="font-size:14px;display:true" cols="160" rows="3" v-model="parsed_result" :visiable="false" ></textarea>
  	<input type="button"  @click="display_result" value="图示" /> &nbsp &nbsp
	<br>
   <hr/>
    <TreeChart :json="data"  @click-node="clickNode" />
    <footer class="foot">
        <p>辽ICP备19011614 | 辽B2-20210778 © 2019 - 2026
            <a target="_blank">大连语智星科技有限公司</a> 
           <a href="http://www.yuzhixing.vip" target="_blank">www.yuzhixing.vip</a> 
        </p>
    </footer>
  </div>
 </template>

<script>
import TreeChart from "@/components/TreeChart";
import Modal from "@/components/Modal.vue";

const crypto = require("crypto");

// 全局配置 自己修改私有化
const safe32 = "23456789ABCDEFGHJKLMNPQRSTUVWXYZ";
const salt = "7sK9dF2gH5jR8tP3qW1x";
const secret = "AuthKey-2026-VIP-Sec";

// 私有置换表 & 反向表
const box = [19,7,25,11,3,22,9,27,14,1,30,16,5,28,12,21,
8,24,4,17,29,10,2,26,13,6,31,15,0,23,18,20];
const revBox = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];

export default {
    name: 'app',
    components: {
        TreeChart,
		Modal
    },
	data() {
		return {
		   //选择的注册服务器网址
		   registerServerUrl_00: 'http://www.langintel.com',
		   registerServerUrl_01: 'https://www.yuzhixing.vip',
		   registerServerUrl_02: 'https://www.langintel.com',
		   registerServerUrl_03: 'https://www.语智星.中国',
		   registerServerUrl_04: 'https://www.gototree.com',
		   strSelectedRegisterServerUrl: '',
		   //远程访问网址 ---//////初始变量，随后被设置文件调整
		   romote_learn_url: '',
		   romote_parse_url: '',
           //本地访问网址
		   local_learn_url: 'http://localhost:8100/post',
           local_parse_url: 'http://localhost:8101/post',
		   //登录结果标志
		   login_mark : false,
		   //基点显示模式
		   basePointShowMode:'labeling',
		   //节点有效的属性值数组
		   relativeNodeArray:[],
		   //管理者查看和修改权限标志
		   managerAuthority: 0,
		   showInput: false,
		   showSecretText: false,
		   clickCount: 0,
		   timer: null,
		   
		   //按钮显示设置-- 隐藏显示
		   showButton_get_user_expired_time: false,
	       showButton_admin_user_using_time: false,
	       showButton_update_resource_parameter: false,
	       showButton_update_resource_access_code: false,  
	       showButton_watch_resource_access_code: false, 
	       showButton_add_resource_access_code: false,
           showButton_create_active_code: false,			   
		   showButton_send_message: false,
		   
		   //备注信息
		   comment: "分词： 1  词义： 2  句法： 3  语义： 4  NER： 5  特例： 6 ",
		   show_mode: "head_word",
		   check_show_number: false,
		   check_show_word: false,
		   check_show_pos: false,
		   check_show_sense: false,
		   check_show_entity: false,
		   check_show_head: false,
		   check_show_relation_count: false,
		   check_show_link: false,
		   check_show_role: false,
		   check_show_template: false,
		   check_romote_port:true,
		   check_simply_show:true,
		   sentence_number_of_template: '1/10000',
		   template_number_on_rank: '1/10',
		   sentence_number_in_sentencebank: '1/1000',
		   sentence_number_in_faqbank: '1/1000',
		   edited_result: '增加',
		   edited_result_style: {
            background: "#0F0"
           },
		   ruled_result: '允许',
		   ruled_result_style: {
            background: "#0F0"
           },
		   match_score: '0.00',
		   match_score_style: {
            background: "#CC8"
           },
		   matched_template_id:'00001',
		   matched_template_id_style: {
            background: "#8CA"
           },

           /////访问标注平台的相关参数
		   //JWT token
           jwt_token:"",
		   //用户库的ID，不是库名
		   userBank_ID:"",
		   //用户工作区的ID，不工作区名
		   userWorkSection_ID:"",
		   //用户选择的领域ID，不是领域名
		   userSelectedDomain_ID:"",
		   //登录标注平台成功标志
           bolLabelingPlatformLoginMark:false,
		   
		   //（查看用）参考基点节点编号
		   view_BaseNode_Position: '1',
		    //（标注用）参考基点节点编号
		   label_BaseNode_Position: '1',
			//当前节点的节点编号
			node_number:"0",
            //点击节点时缓冲保存
			node_buffer: null,
			//之前节点状态保留，因为缓存的状态也被改变过
			nodeLastState: '0',
			//指定的查找节点
			foundNode:null,
			//查找的节点的索引
			SpecifiedNodeIndex:0,
			//查找和标注树节点变量
			m_parentNode: null,
            m_attribute: null,
			rootNodeCount: 0,
			HeadSelectUpdateMode:"WithClear",
			//用户微信编号
			weixin_number:"微信用户_",
		    //声明和初始化数据
			input_sentence: "我 昨天 和 部队 朋友 在 市场 买 了 这些 奥运 邮票 。", //"请在这里输入句子！",
			faq_question:"",
			faq_answer:"",
			faq_action:"",
			faq_meaning:"",
			verified_result: '0',
			output_understanding: "",
			//初始化分析结果的数据
			parsed_result: "",//(C4:=.AD+PN+P+NR+PU/Fa070104+Ab010101+Na010102+Za030102+Ww040101~!0<<2.成事关系-Exp:01-W2>>那时+我+在+上海+。 (C3:=.AD+PN+P+NR/Fa070104+Ab010101+Na010102+Za030102~事件!1<<>>那时+我+在+上海 (W1:.AD/Fa070104~时间!0<<>> 那时) (C2:=.PN+P+NR/Ab010101+Na010102+Za030102~状态!1<<>>我+在+上海 (W2:.PN/Ab010101~!1<<2.成事关系-Exp:01-C4>> 我) (C1:=.P+NR/Na010102+Za030102~!1<<>>在+上海 (W3:.P/Na010102~!1<<1:Time;2:Exp;4:Loc;5:mPunc>> 在) (W4:.NR/Za030102~地点!1<<处所>> 上海) ) ) ) (W5:.PU/Ww040101~!0<<>> 。) )",
			bank_name: "Bank0",
			section_name: "WorkSection0",
			user_name: "guest",
			password:"******",
			//测试集
			select_testset_value: "临时句子库",
			//句子编号
			sentence_number: "1",
			//自动分词选项
			auto_word_segment: "true",
			//绝对编号模板指针
			absolute_template_pointer: 1,
			//候选模板指针
			rank_template_pointer: 1,
			//子数据指针
			sub_template_number:"1",
			//学习模式的操作命令
			run_operation: "ADD",
			//用户机器人编号
			ur_number_in_document:"1/1",
			//第三方资源编号
			resource_number_in_document:"1/1",
			
 		    data: {
				role: "role0",
				state: "1",
				relation_count: "■",
				link: "link0",
				head: "■■■",
				entity: "entity0",
				sense: "sense0",
				pos: "pos0",
				word: "children0",
				number: "C1",
				node_content: "root",		
				node_attribute: "0", 
			    children: [
				{
					role: "role1",
					state: "101100",
					relation_count: "■",
					link: "link1",
				    head: "■■■",
					entity: "entity1",
					sense: "sense1",
					pos: "pos1",
					word: "children1",
					number: "W1",
					node_content: "root",		
					node_attribute: "1"
				},
				{
					role: "role100",
					state: "11101",
					link: "link100",
					relation_count: "■",
				    head: "---",
					entity: "entity100",
					sense: "sense100",
					pos: "pos100",
					word: "children100",
					number: "C2",
					node_content: "root",		
					node_attribute: "2", 
					children: [
					{
						role: "role2",
						state: "111",
						link: "link2",
					    relation_count: "■",
				        head: "■■■",
						entity: "entity2",
						sense: "sense2",
						pos: "pos2",
						word: "children2",
						number: "W2",
						node_content: "root",		
						node_attribute: "2" 
					},
					{
						role: "role3",
						state: "100011",
						link: "link3",
					    relation_count: "■",
				        head: "■■■",
						entity: "entity3",
						sense: "sense3",
						pos: "pos3",
						word: "children3",
						number: "W3",
						node_content: "root",		
						node_attribute: "1"

					}]
				}]
		    }
	    }
	},
	created(){
	    //检测键盘按键
        var _this = this;
        document.onkeydown = function(e) {
        _this.keysubmit(e.key,e.ctrlKey);

        };
 		
    },
	proxyTable :{
		'api':{
			target:'',
			changeOrigin:true,
			pathRewrite:{
			  '^/api': ''
			}
		}
	},
    mounted(){
	    //设置标题
		document.title='语智星语言分析器'; 
		//读取开机配置文件
		this.LoadConfiguration();
		//读取选择的注册服务器网站
		this.LoadSelectedRegisterServerUrl();
		//读取开机显示原始树
		this.ShowInintializationParsedTree();
    },
    methods: {
		keysubmit: function(key,ctrlkey) {
			//是组合键？CTL +1 --位置前进
			if( key === '1' && ctrlkey === true)
			{
				this.jump_next_node()
			}
			//是组合键？CTL +2 --位置回退
			if( key === '2' && ctrlkey === true)
			{
				this.jump_last_node()
			}
		},
			
			//为单节点去重优化
			OptimizeTemplateForDeduplicateRootNode:function(strTemplate){
				var strTemplatePrePart = "";
				var intPos = 0;
				var strSemanticDescription = "";
				while(strTemplate != ""){
				   intPos = strTemplate.indexOf("<<"); 
				   if (intPos != -1){
					   strTemplatePrePart += strTemplate.substring(0,intPos);
					   strTemplate = strTemplate.substring(intPos + "<<".length,strTemplate.length);
					   //得到语义描述部分
					   strSemanticDescription = strTemplate.substring(0,strTemplate.indexOf(">>"));
					   //去掉语义重复根节点部分
					   strSemanticDescription = this.DeduplicateRootNode(strSemanticDescription);
					   //前部加上更新的语义描述部分
					   strTemplatePrePart += "<<" + strSemanticDescription + ">>";				   
					   //剩余部分
					   strTemplate = strTemplate.substring(strTemplate.indexOf(">>") + ">>".length,strTemplate.length);	
				   }else{
					   strTemplatePrePart += strTemplate;
					   strTemplate = "";
				   }
				}
				return strTemplatePrePart;
			},
			
			//去掉语义重复单节点部分
			DeduplicateRootNode: function(strTempSemanticDescription){
			    var strNewSemanticPart = "";
			    var intPos = 0;
				var strOneSemanticUnit = "";
				var arraySemanticDesription = new Array();
				while(strTempSemanticDescription != ""){
				   intPos = strTempSemanticDescription.indexOf(","); 
				   if (intPos != -1){
					   strOneSemanticUnit = strTempSemanticDescription.substring(0,intPos);
					   strTempSemanticDescription = strTempSemanticDescription.substring(intPos + 1,strTempSemanticDescription.length);
				   }else{
				       strOneSemanticUnit = strTempSemanticDescription;
					   strTempSemanticDescription = "";
				   }
				   //选取的部分写入数组
				   arraySemanticDesription.push(strOneSemanticUnit);
				}
				//过滤数组
				let arraySemanticDesriptionFilter = [...new Set(arraySemanticDesription)];
				//得到过滤后结果
                strNewSemanticPart = arraySemanticDesriptionFilter.join(",");
				return strNewSemanticPart;
            },
		//读取开机配置文件
		LoadConfiguration(){		
		//读取文件
		var learn_port = ''
		var parse_port = ''
		var tempData = ""
		var tempLine = ""
		var tempKey = ""
		var tempValue = ""
		const FileConfigUrl = '/static/config.txt'
	    this.$http.get(FileConfigUrl)
	      .then(res => {
	        tempData = res.data
			while (tempData != ""){
			    if (tempData.indexOf("\r") != -1){
				    tempLine = tempData.substring(0,tempData.indexOf("\r"))
					tempData = tempData.substring(tempData.indexOf("\r") + 1,tempData.length)
				}else{
					tempLine = tempData
					tempData = ""
				}
				if(tempLine.indexOf(":") != -1){
				   //得到键
				   tempKey = tempLine.substring(0,tempLine.indexOf(":"))
				   tempKey  = tempKey.trim()
				   //得到值
				   tempValue = tempLine.substring(tempLine.indexOf(":") + 1,tempLine.length)
				   tempValue  = tempValue.trim()
				}
				if(tempKey == 'learn_port'){//学习模板和同义词端口?
				    //更新端口值
					learn_port = tempValue
					console.log("学习模板和同义词的端口--设置为:" + learn_port)
				}
				if(tempKey == 'parse_port'){//句法语义分析端口?
				    //更新端口值
					parse_port = tempValue
					console.log("句法语义分析的端口--设置为:" + parse_port)
				}
				if(tempKey == 'bank_name'){//选择库名?
				    //更新选择的库名
					this.bank_name = tempValue
					console.log("当前选择库:" + this.bank_name)
				}
				if(tempKey == 'section_name'){//选择工作区?
				    //更新选择的工作区名
					this.section_name = tempValue
					console.log("当前选择工作区:" + this.section_name)
				}
			}
		    //设置配置数据
		    this.romote_learn_url = this.strSelectedRegisterServerUrl + ':' + learn_port + '/post';
		    this.romote_parse_url = this.strSelectedRegisterServerUrl + ':' + parse_port + '/post';
            //本地访问网址
		    this.local_learn_url = 'http://localhost:' + learn_port + '/post';
            this.local_parse_url = 'http://localhost:' + parse_port + '/post';
			console.log("远程学习模板和同义词的端口" +  this.romote_learn_url)
			console.log("本地学习模板和同义词的端口" + this.local_learn_url)
			console.log("远程句法语义分析的端口" + this.romote_parse_url)
			console.log("本地句法语义分析的端口：" + this.local_parse_url)		   
		   })
          .catch(error => {
 		    //显示错误
            alert("error-配置文件读取");
          });   
        },
		//读取选择的注册服务器网站
		LoadSelectedRegisterServerUrl(){		
		//读取文件
		const FileSelectServerUrl = '/static/SSS_Web.txt'
	    this.$http.get(FileSelectServerUrl)
	      .then(res => {
             //初始值
			 this.strSelectedRegisterServerUrl = this.registerServerUrl_01
			 //原始数据
			 var strConfigureData = res.data
			  //alert(strConfigureData)
			 if (strConfigureData == "10000"){//是第一个选择网址？
			    //设置常规网址
			    this.strSelectedRegisterServerUrl = this.registerServerUrl_01
			 }
			 else if (strConfigureData == "10800"){//是第二个选择网址（备用）？
			    //设置备用网址
			    this.strSelectedRegisterServerUrl = this.registerServerUrl_02
			 }
			 else if (strConfigureData == "20800"){//是第三个选择网址（备用）？
			    //设置备用网址
			    this.strSelectedRegisterServerUrl = this.registerServerUrl_03
			 }
			 else if (strConfigureData == "30800"){//是第四个选择网址（备用）？
			    //设置备用网址
			    this.strSelectedRegisterServerUrl = this.registerServerUrl_04
			 }
			 else if (strConfigureData == "88000"){//是第0个选择网址（非https）？
			    //设置备用网址
			    this.strSelectedRegisterServerUrl = this.registerServerUrl_00
			 }
			 //设置远程访问网址
		     this.romote_learn_url = this.strSelectedRegisterServerUrl + ':8000/post'
		     this.romote_parse_url = this.strSelectedRegisterServerUrl + ':8001/post'
			 
			 //alert("选择的注册服务器网址：" + this.strSelectedRegisterServerUrl);
		  })
          .catch(error => {
 		    //显示错误
            alert("读取文件：" + FileSelectServerUrl + " -- error !");
          });   
        },		
		//读取开机显示原始树
		ShowInintializationParsedTree(){		
		//读取文件
		const FileUrl = '/static/data.json'
	    this.$http.get(FileUrl)
	      .then(res => {
			 //句法树数据
			 this.rootNodeCount = 0
			 //得到对句法树子信息解析的句法树
			 this.get_tree_with_subinformation(res.data);
		  })
          .catch(error => {
 		    //显示错误
            alert("error");
          });   
        },
		//模板学习
		learn_template: function(){	
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_learn_url;
			}else{
				use_IP_url = this.local_learn_url;
			}
			//当前时间
			var dateTimeData = new Date();
		    var selectMark;
			//备注信息
			this.comment= "分词： 1X  词义： 2X  句法： 3X  语义： 4X  NER： 5X  特例： 6X ";
	   	    //建立模板学习标志
			selectMark = "Template"
			//模板内容
		    var template_content = this.parsed_result;
			if (template_content.indexOf("(") == -1 ||template_content.indexOf(")") == -1){
			    alert("错误，当前输入的句法树数据不是带左右括号的格式数据！")
				return
			}
			//在区内的纯模板的句子编号（不带/总数量）
			var sentence_number_for_template = "";
			if (this.sentence_number_of_template.indexOf("/") != -1){
			   sentence_number_for_template = this.sentence_number_of_template.substring(0,this.sentence_number_of_template.indexOf("/"))
			}
			else{
			   sentence_number_for_template = this.sentence_number_of_template
			}
			//建立库名,区名,用户名，自动模式标志，操作命令，候选模板指针
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + "true" + "/" + this.run_operation + "--0--0.0.0.0" + "=" + sentence_number_for_template + "#" + this.sub_template_number + "%" + this.comment + "&" + dateTimeData;  
			var send_data={
			      //发送模板
                  id:selectMark,
				  option:option_data,//建立选项数据
                  data:template_content //模板内容
            };
			alert("id:" + selectMark + "; " + "option:" + option_data + "; " + "data:" + "\r\n" + template_content);
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){
				//返回学习的结果
				alert("模板学习--" + res.data);
			},function(res){
			 //显示错误
			 alert(res.status)
			});
		},
		//同义词学习
		learn_tongyici: function(){	

		    //判断是否登录成功
		 //   if(this.login_mark != true){
		//		alert("请先登录成功再操作！");
		//		return
		//	}

			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_learn_url;
			}else{
				use_IP_url = this.local_learn_url;
			}
			//当前时间
			var dateTimeData = new Date();
		    var selectMark;
		    //建立模板学习标志
			selectMark = "TongYiCi"
			//备注内容
			this.comment = "0"
			//同义词内容
		    var tongyici_content = this.parsed_result; //格式 "词 语义码"
			//建立库名,区名,用户名，自动模式标志，操作命令，候选模板指针，候选模板指针
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + "true" + "/" + this.run_operation + "--0--0.0.0.0" + "=" + this.candiate_template_number + "#" + this.sub_template_number + "%" + this.comment + "&" + dateTimeData;  
			var send_data={
			      //发送同义词
                  id:selectMark,
				  option:option_data,//建立选项数据
                  data:tongyici_content //同义词内容
            };
			alert("id:" + selectMark + "; " + "option:" + option_data + ";" + "data:" + "\r\n" + tongyici_content);
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){
				//返回学习的结果
				alert("同义词学习--" + res.data);
			},function(res){
			 //显示错误
			 alert(res.status)
			});
		},
		//新建库区
		create_bank_section: function(){	
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_learn_url;
			}else{
				use_IP_url = this.local_learn_url;
			}
			//当前时间
			var dateTimeData = new Date();
		    var selectMark;
		    //建立对所有类
			selectMark = "All"
			//备注内容
			this.comment = "0"
			//数据内容
		    var data_content = ""; //空-数据内容
			//建立库名,区名,用户名，自动模式标志，操作命令，候选模板指针，候选模板指针
			var option_data = this.bank_name + ":" + this.section_name + "@" + "guest" + "$" + "true" + "/" + "CreateNewBankAndSection" + "--0--0.0.0.0" + "=" + "0" + "#" + "0" + "%" + this.comment + "&" + dateTimeData;   
			var send_data={
			      //发送新建库区
                  id:selectMark,
				  option:option_data,//建立选项数据
                  data: data_content//数据内容
            };
			alert("id:" + selectMark + "; " + "option:" + option_data + ";" + "data:" + "\r\n" + data_content);
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){
				//返回新建库区的结果
				alert("新建库区--" + res.data);
			},function(res){
			 //显示错误
			 alert(res.status)
			});
		},
		//建立用户IP
		set_user_ip_duration: function(){	
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_learn_url;
			}else{
				use_IP_url = this.local_learn_url;
			}
			//当前时间
			var dateTimeData = new Date();
		    var selectMark;
		    //建立对所有类
			selectMark = "All"
			//备注内容
			this.comment = "0"
			//用户IP内容
		    var data_content = this.parsed_result; //格式 "127.0.0.1=02 Jan 21 15:04 UTC--28 Apr 22 15:00 UTC"; 
			//建立库名,区名,用户名，自动模式标志，操作命令，候选模板指针，候选模板指针
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + "true" + "/" + "SetUserIPDuration" + "--0--0.0.0.0" + "=" + "0" + "#" + "0" + "%" + this.comment + "&" + dateTimeData;  
			var send_data={
			      //发送数据
                  id:selectMark,
				  option:option_data,//建立选项数据
                  data: data_content//数据内容
            };
			alert("id:" + selectMark + "; " + "option:" + option_data + ";" + "data:" + "\r\n" + data_content);
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){
				//返回建立用户IP的结果
				alert("建立用户IP--" + res.data);
			},function(res){
			 //显示错误
			 alert(res.status)
			});
		},
		//设置语义码匹配长度
		set_semanticcode_matchLength: function(){	
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_learn_url;
			}else{
				use_IP_url = this.local_learn_url;
			}
			//当前时间
			var dateTimeData = new Date();
		    var selectMark;
		    //建立对所有类
			selectMark = "All"
			//备注内容
			this.comment = "0"
			//语义码内容
		    var semantic_code_match_data = this.parsed_result; //格式 "语义码 长度 "
			if(semantic_code_match_data.indexOf(" ") == -1) {
				alert("错误，语义码数据必须有空格“ ” ！")
				return
			}
			var sematnic_code_content = semantic_code_match_data.substring(0,semantic_code_match_data.indexOf(" "))
			var sematnic_code_match_length = semantic_code_match_data.substring(semantic_code_match_data.indexOf(" ") +1,semantic_code_match_data.length)
			if(sematnic_code_content.length != 8){
				alert("错误，语义码的长度数据必须8位字符 ！")
				return
			}
			if(sematnic_code_match_length.length != 1){
				alert("错误，语义码的长度数据必须一位数字1-8 ！")
				return
			}
			//建立库名,区名,用户名，自动模式标志，操作命令，候选模板指针，候选模板指针
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + "true" + "/" + "CodeMatchLength" + "--0--0.0.0.0" + "=" + "0" + "#" + "0" + "%" + this.comment + "&" + dateTimeData;  
			var send_data={
			      //发送语义码匹配长度
                  id:selectMark,
				  option:option_data,//建立选项数据
                  data:semantic_code_match_data //数据内容
            };
			alert("id:" + selectMark + "; " + "option:" + option_data + ";" + "data:" + "\r\n" + semantic_code_match_data);
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){
				//返回设置语义码匹配长度的结果
				alert("语义码匹配长度设置--" + res.data);
			},function(res){
			 //显示错误
			 alert(res.status)
			});
		},
		isNumber: function(obj) {
		  var reg = /^(-|\+)?\d+$/ ;
		  if (reg.test(obj)) {
			return true;
		  }
		  return false;
		},　
		//下载模板
		download_template: function(){	
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_learn_url;
			}else{
				use_IP_url = this.local_learn_url;
			}
			//当前时间
			var dateTimeData = new Date();
		    var selectMark;
		    //建立对所有类
			selectMark = "All"
			//备注内容
			this.comment = "0"
			//用户IP内容
		    var data_content = this.parsed_result; //格式 "127.0.0.1=02 Jan 21 15:04 UTC--28 Apr 22 15:00 UTC"; 
			//建立库名,区名,用户名，自动模式标志，操作命令，候选模板指针，候选模板指针
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + "true" + "/" + "SetUserIPDuration" + "--0--0.0.0.0" + "=" + "0" + "#" + "0" + "%" + this.comment + "&" + dateTimeData;  
			var send_data={
			      //发送数据
                  id:selectMark,
				  option:option_data,//建立选项数据
                  data: data_content//数据内容
            };
		},
		click_check_show_number: function(){
			if(this.check_show_number){
		//		alert("已设置显示编号！");
				localStorage.setItem("check_show_number","true");
			}else{
		//	    alert("已取消显示编号！");
				localStorage.setItem("check_show_number","false");
			}
        },
		click_check_show_word: function(){
			if(this.check_show_word){
		//		alert("已设置显示词！");
				localStorage.setItem("check_show_word","true");
			}else{
		//	    alert("已取消显示词！");
				localStorage.setItem("check_show_word","false");
			}
        },
		click_check_show_pos: function(){
			if(this.check_show_pos){
		//		alert("已设置显示词性！");
				localStorage.setItem("check_show_pos","true");
			}else{
		//	    alert("已取消显示词性！");
				localStorage.setItem("check_show_pos","false");
			}
        },
		click_check_show_sense: function(){
			if(this.check_show_sense){
		//		alert("已设置显示语义码！");
				localStorage.setItem("check_show_sense","true");
			}else{
		//	    alert("已取消显示语义码！");
				localStorage.setItem("check_show_sense","false");
			}
        },
		click_check_show_entity: function(){
			if(this.check_show_entity){
		//		alert("已设置显示命名实体！");
				localStorage.setItem("check_show_entity","true");
			}else{
		//	    alert("已取消显示命名实体！");
				localStorage.setItem("check_show_entity","false");
			}
        },
		click_check_show_head: function(){
			if(this.check_show_head){
		//		alert("已设置显示中心词！");
				localStorage.setItem("check_show_head","true");
		        check_show_head = true;
			}else{
		//	    alert("已取消显示中心词！");
				localStorage.setItem("check_show_head","false");
		        check_show_head = false;
			}
        },
		click_check_show_relation_count: function(){
			if(this.check_show_relation_count){
		//		alert("已设置显示关联度！");
				localStorage.setItem("check_show_relation_count","true");
			}else{
		//	    alert("已取消显示关联度！");
				localStorage.setItem("check_show_relation_count","false");
			}
        },
		click_check_show_link: function(){
			if(this.check_show_link){
		//		alert("已设置显示语义关联！");
				localStorage.setItem("check_show_link","true");
			}else{
		//	    alert("已取消显示语义关联！");
				localStorage.setItem("check_show_link","false");
			}
        },
		click_check_show_template: function(){
			if(this.check_show_template){
		//		alert("已设置显示匹配模板！");
				localStorage.setItem("check_show_template","true");
			}else{
		//	    alert("已取消显示匹配模板！");
				localStorage.setItem("check_show_template","false");
			}
        },
		click_check_simply_show: function(){
			if(this.check_simply_show){
		//		alert("已设置简化显示！");
				localStorage.setItem("check_simply_show","true");
			}else{
		//	    alert("已取消简化显示！");
				localStorage.setItem("check_simply_show","false");
			}
        },		
		//得到对句法树子信息解析的句法树
		get_tree_with_subinformation(base_tree){
			//转换标注树 JSON对象为字符串
			var myTreeObj = JSON.stringify(base_tree);
            //增加节点的子信息属性项--初始值为空值
			myTreeObj = myTreeObj.replace(/"node_content"/g, '"role":"","state":"","link":"","head":"","entity":"","sense":"","pos":"","word":"","number":"","node_content"')
			myTreeObj = eval('('+ myTreeObj + ')');
			//建立节点属性的子信息
			this.set_node_subinformation(myTreeObj);
			this.data= myTreeObj;
		},	
		//建立节点属性的子信息
		set_node_subinformation(myTreeObj){
		    var temp;
			var number;
		    var word;
			var chunk_name;
			var pos;
			var sense;
			var entity;
			var head;
			var relation_count;
			var link;
			var state;
			var role;
			var intGapPostion;
			//1.第一层 root 深度遍历整个JSON
			for(var i in myTreeObj) {
				//2.有节点就开始找，一直递归下去
				if (i === "node_attribute") {
				    //得到原始整体属性内容
					temp = myTreeObj["node_attribute"]
					//是组块?
					if(temp.substring(0,1) === "C"){
				       //得到组块编号
						intGapPostion = temp.indexOf(":")
						if (intGapPostion != -1) {
						   //得到一个子信息数据
						   number = temp.substring(0,intGapPostion)
						   //剩余数据
						   temp = temp.substring(intGapPostion+1,temp.length)
						}
						else{
							alert("错误，句法树节点的编号格式错误！")
						}
				    }
					//是词?
					else if(temp.substring(0,1) === "W"){
				       //得到词编号
						intGapPostion = temp.indexOf(":")
						if (intGapPostion != -1) {
						   //得到一个子信息数据
						   number = temp.substring(0,intGapPostion)
						   //剩余数据
						   temp = temp.substring(intGapPostion+1,temp.length)
						}	
						else{
							alert("错误，句法树节点的编号格式错误！")
						}
					}
					else{
						alert(temp.substring(0,1))
					    alert("句法树格式错误！标号表示既不是组块C，也不是词W");
					}
					//得到组块名
					chunk_name = ""
				    intGapPostion = temp.indexOf(".")
				    if (intGapPostion != -1) {
					   //得到一个子信息数据
					   chunk_name = temp.substring(0,intGapPostion)
					   //剩余数据
					   temp = temp.substring(intGapPostion+1,temp.length)
				    }
					//得到词性
					pos = ""
				    intGapPostion = temp.indexOf("/")
				    if (intGapPostion != -1) {
					   //得到一个子信息数据
					   pos = temp.substring(0,intGapPostion)
					   //剩余数据
					   temp = temp.substring(intGapPostion+1,temp.length)
				    }
				    //得到词义
					sense = ""
				    intGapPostion = temp.indexOf("~")
				    if (intGapPostion != -1) {
					   //得到一个子信息数据
					   sense = temp.substring(0,intGapPostion)
					   //剩余数据
					   temp = temp.substring(intGapPostion+1,temp.length)
				    }
				    //得到命名实体
					entity = ""
				    intGapPostion = temp.indexOf("!")
				    if (intGapPostion != -1) {
					   //得到一个子信息数据
					   entity = temp.substring(0,intGapPostion)
					   //剩余数据
					   temp = temp.substring(intGapPostion+1,temp.length)
				    }
				    //得到中心词
					head = ""
				    intGapPostion = temp.indexOf("<<")
				    if (intGapPostion != -1) {
					   //得到一个子信息数据
					   head = temp.substring(0,intGapPostion)
					   if(head == "1"){
					       head = "■■■";
					   }else{
					       head = "---";
					   }
					   //剩余数据
					   temp = temp.substring(intGapPostion+2,temp.length)
				    }
				    //得到语义关联
					link = ""
				    intGapPostion = temp.indexOf(">>")
				    if (intGapPostion != -1) {
					   //得到一个子信息数据
					   link = temp.substring(0,intGapPostion)
					   //剩余数据
					   temp = temp.substring(intGapPostion+2,temp.length)
				    }
				}
				else if (i === "node_content") {
				    //写词内容
					word = myTreeObj["node_content"]
					myTreeObj["word"] = word;
				}
 				//3.如果有子节点，就从子节点开始找
				else if (i === "children") {
					//从数组中取对象
					for(var j in myTreeObj[i]) {
					   //递归往下找
					   if (j != null ){
						  this.set_node_subinformation(myTreeObj[i][j]);
					   }
					}
				}
			}
			
			//写编号内容
			myTreeObj["number"] = number;
			//写词性内容(组块名和词性共用)
			myTreeObj["pos"] = chunk_name + "." + pos;
			//写词义内容
			myTreeObj["sense"] = sense;
			//写命名实体内容
			myTreeObj["entity"] = entity;
			//写中心词内容
			myTreeObj["head"] = head;
			//写语义关联内容
			//只显示节点编号
			var temp_link = "";
			var one_node_number;
			temp_link = link;
			//清除关联度
			relation_count = ""
			link = "";
			while(temp_link != "")
			{
			   if(temp_link.indexOf(",") != -1)  {
			      one_node_number = temp_link.substring(0,temp_link.indexOf(","));
				  temp_link = temp_link.substring(temp_link.indexOf(",") +1,temp_link.length);
			   }
			   else{
			      one_node_number = temp_link;
				  temp_link = "";
			   }
			   //得到编号部分
			   one_node_number = one_node_number.substring(one_node_number.indexOf(":")+1,one_node_number.length);//去掉关系类型
			   one_node_number = one_node_number.substring(one_node_number.indexOf("-")+1,one_node_number.length);//去掉方向
			   //建立关联节点编号链
			   if(link == ""){
			      link = one_node_number;
			   }
			   else {
			      link += "," + one_node_number;
			   }
			   //建立关联度计数
			   relation_count += "■"
			}
			//写关联度
			myTreeObj["relation_count"] = relation_count;
			//写语义关系
			myTreeObj["link"] = link;
			
			//写显示状态内容
			myTreeObj["state"] = "22";

		},
	    //读取当前的节点的属性值数据
		ReadThisNodeAttributeData(m_attribute)  {
		    if (m_attribute == "")
			    return;
		    //清除关联的范围符号
			if(m_attribute.indexOf("<<") != -1)
			{
			   m_attribute = m_attribute.substring(m_attribute.indexOf("<<") + 2,m_attribute.length);
			}
			if(m_attribute.indexOf(">>") != -1)
			{
			   m_attribute = m_attribute.substring(0,m_attribute.indexOf(">>"));
			}
			//清除属性值数据
			//样例：2.当事关系-Exp:01-W1,3.感事关系-Aft:10-W2,5.受事关系-Pat:10-C2,
			//处理每一个属性名和数值
			var tempOneAttributeData  = ""
			var intGapPostion = 0
			var tempAttributeName = ""
			var AttributeNameindex = ""
			var directionData = ""
			var relativeNode = ""
			var intRelavteNodeCount = 0
			//清数组计数
			this.relativeNodeArray[0] = '0'
            while(m_attribute != "") {
			   //得到一个属性数据的结尾位置
			   intGapPostion = m_attribute.indexOf(",")
			   if (intGapPostion != -1) {
				   //得到一个属性数据
				   tempOneAttributeData = m_attribute.substring(0,intGapPostion)
				   //剩余的属性数据序列
				   m_attribute = m_attribute.substring(intGapPostion+1,m_attribute.length)
			   }
			   else {
			       tempOneAttributeData = m_attribute
				   m_attribute = ""
			   }
			   //得到属性名
			   intGapPostion = tempOneAttributeData.indexOf(":")
			   tempAttributeName = tempOneAttributeData.substring(0,intGapPostion)
			   //剩余部分
			   tempOneAttributeData = tempOneAttributeData.substring(intGapPostion+1,tempOneAttributeData.length)
			   //得到属性名索引
			   intGapPostion = tempAttributeName.indexOf(".")
			   AttributeNameindex = tempAttributeName.substring(0,intGapPostion)
			   //得到方向数据
			   intGapPostion = tempOneAttributeData.indexOf("-")
			   directionData = tempOneAttributeData.substring(0,intGapPostion)
			   tempOneAttributeData = tempOneAttributeData.substring(intGapPostion+1,tempOneAttributeData.length)
			   //得到关联的卫星节点编号
			   relativeNode = tempOneAttributeData
			   ///是标注显示模式，全部显示关联的节点
			   //节点数组指针+1
			   intRelavteNodeCount++
			   //写入相关节点编号值
			   this.relativeNodeArray[intRelavteNodeCount] = relativeNode
			   //建立有效的关联节点数量
			   this.relativeNodeArray[0] = String(intRelavteNodeCount)			   
			}
		},
		//先分词，人工校对后再进行分析
		revise_cutting_word()
		{
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_parse_url;
			}else{
				use_IP_url = this.local_parse_url;
			}
			//当前时间
			var dateTimeData = new Date();
		    //选择句库标志
		    var selectMark;
		    //建立分词修正标志
			selectMark = "CutWord"
			//备注内容
			this.comment = "0"
			//句子内容
		    var test_sentence = this.input_sentence;
			//清除当前的空格
			let reg=new RegExp(' ','g')
			test_sentence = test_sentence.replace(reg,'')
			//建立库名,区名,用户名，自动分词标志，显示模板标志，候选模板指针
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + this.auto_word_segment + "/" + this.passWord +  "--" + m_user_host_serial_number + "--" + m_user_host_ip_address + "=" + this.candiate_template_number + "#" + this.sub_template_number + "%" + this.comment + "&" + dateTimeData;   
			var send_data={
			      //发送测试句子
                  id:selectMark,
				  option:option_data,//建立选项数据
                  data:test_sentence //句子内容
            };
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){
				//返回的分词结果
				this.input_sentence = res.data;
			},function(res){
			 //显示错误
			 alert(res.status)
			});
		},		
	    ///将逻辑值转换为0/1的字符串
	    BTString: function (bolValue) {
	     var strValue
	     if(bolValue == true){
		     strValue = "1"
		 }else {
		 	 strValue = "0"
		 }
         return strValue		 
	    },
	    //点击节点的处理
		clickNode: function(node){
			/////////得到当前点击节点的位置//////////
			// 获取节点距离浏览器视口的高度
			var top = event.currentTarget.getBoundingClientRect().top;
			// 获取节点距离浏览器视口的宽度
			var left = event.currentTarget.getBoundingClientRect().left;
			// 获取滚动条滚动距离
			var scrollTop=document.body.scrollTop||document.documentElement.scrollTop;
			// 两个top相加就是节点真正的top值
			top = top+scrollTop;
			var scrollLeft=document.body.scrollLeft||document.documentElement.scrollLeft;
			// 两个left相加就是节点真正的left值
			left = left+scrollLeft;
			//////////显示节点信息/////////
			//转换标注树 JSON对象为字符串
			var myTreeObj 
			myTreeObj = JSON.stringify(this.data);
			myTreeObj = eval('('+ myTreeObj + ')');
			//清节点计数
			this.rootNodeCount = 0
			//按节点编号查找节点的索引
			this.node_number =node.number
			this.findSpecifiedNodeIndexByNodeNumber(myTreeObj)
			//建立节点为当前的关联节点
			this.jump_node_by_number()
        },
 		//前一个节点
		jump_last_node: function(){
		    var node_num = String(this.label_BaseNode_Position);
			//有分割符?
		    if (node_num.indexOf("/") != -1){
			     //得到纯编号
			     node_num = node_num.substring(0,node_num.indexOf("/"))
			}
			var intNumber = Number(node_num)
			//指针减一
			if (intNumber != 1){
			   intNumber = intNumber -1
			}else {
			   alert("警告！当前已经是最前的一个句子。")
			}
			//更新当前值
			this.label_BaseNode_Position = String(intNumber)
			//建立节点为当前的关联节点
			this.jump_node_by_number()
		},
		//后一个节点
		jump_next_node: function(){
		    var node_num = String(this.label_BaseNode_Position);
			//有分割符?
		    if (node_num.indexOf("/") != -1){
			     //得到纯编号
			     node_num = node_num.substring(0,node_num.indexOf("/"))
			}
			var intNumber = Number(node_num)
			//指针加一
			if (intNumber < 10){
			   intNumber = intNumber +1
			}else {
			   alert("警告！当前已经是最后的一个句子。")
			}
			//更新当前值
			this.label_BaseNode_Position = String(intNumber)
			//建立节点为当前的关联节点
			this.jump_node_by_number()
			//是当前的跳转的节点编号大于当前树最大的节点数?
			if (this.rootNodeCount < intNumber) {
				//恢复原来值
				this.label_BaseNode_Position = String(intNumber -1);
			    alert("警告，当前跳转的节点编号不可以大于当前树的最大节点数!");
			    //再一次重新，建立节点为当前的关联节点
				this.jump_node_by_number()
			}
		},
		jump_node_by_number: function()	{
		    //转换标注树 JSON对象为字符串
			var myTreeObj = JSON.stringify(this.data);
			myTreeObj = eval('('+ myTreeObj + ')');
			//清节点计数
			this.rootNodeCount = 0
			//清除显示焦点
			this.clearAllNodeShowMark(myTreeObj)
			//更新当前的显示树
			this.data = myTreeObj
			//清节点计数
		    this.rootNodeCount = 0
			//建立设置基点节点的标识，为了读取基点的属性到数组
			this.basePointShowMode = 'BasePointSetting'
			//建立指定查找的基点索引位置
			this.SpecifiedNodeIndex = this.label_BaseNode_Position
			/////递归查询JSON树,找到指定索引的节点//////////////
		    this.findSpecifiedNodeIndexByNodeNumber(myTreeObj);
			//读取当前的节点的属性值数据,为了显示卫星节点状态
			this.ReadThisNodeAttributeData(this.foundNode.node_attribute);

			//0.递归前，记录当前节点作为parent 父节点
			//清节点计数
		    this.rootNodeCount = 0
		    var root_parentNode = myTreeObj
			this.setHeadWordNodeMark(myTreeObj,root_parentNode)
			this.setAllNodeMark(myTreeObj);
			//更新当前的显示树
			this.data = myTreeObj
		},
 		//跳转到句库中上一句
		jump_last_sentence_number_in_sentencebank: function(){
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}		    
			var sentence_num = this.sentence_number_in_sentencebank;
			//有分割符?
		    if (sentence_num.indexOf("/") != -1){
			     //得到纯编号
			     sentence_num = sentence_num.substring(0,sentence_num.indexOf("/"))
			}
			var intNumber = Number(sentence_num)
			//指针减一
			if (intNumber > 1){
			   intNumber = intNumber -1
			}else {
			   alert("警告！当前已经是最前的一个句子。")
			}
			//更新当前值
			this.sentence_number_in_sentencebank = String(intNumber)
			//重新调用
			this.jump_now_sentence_number_in_sentencebank()
		},
		//跳转到句库中下一句
		jump_next_sentence_number_in_sentencebank: function(){
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}		    
			var sentence_num = this.sentence_number_in_sentencebank;
			//有分割符?
		    if (sentence_num.indexOf("/") != -1){
			     //得到纯编号
			     sentence_num = sentence_num.substring(0,sentence_num.indexOf("/"))
			}
			var intNumber = Number(sentence_num)
			//指针加一
			if (intNumber < 10000){
			   intNumber = intNumber +1
			}else {
			   alert("警告！当前已经是最后的一个句子。(目前暂设置最多10000个句子实验)")
			}
			//更新当前值
			this.sentence_number_in_sentencebank = String(intNumber)
			//重新调用
			this.jump_now_sentence_number_in_sentencebank()
		},
		//跳转到跳转到句库中指定编号的句子
		jump_now_sentence_number_in_sentencebank: function(){
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}			
			var sentence_num = this.sentence_number_in_sentencebank;
			//有分割符?
		    if (sentence_num.indexOf("/") != -1){
			     //得到纯编号
			     sentence_num = sentence_num.substring(0,sentence_num.indexOf("/"))
			}
			var intNumber = Number(sentence_num)
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_parse_url;
			}else{
				use_IP_url = this.local_parse_url;
			}
			//当前时间
			var dateTimeData = new Date();
			//只显示句库中句子，不显示模板内容
			//this.check_show_template = false;
		    //选择句库标志
		    var selectMark;
		   //建立选择句库句分析标志
			selectMark = "LoadSenteceInSentenceBank"
			//备注内容
			this.comment = "0"
			//句子内容
			var test_sentence = "?"
			//建立库名,区名,用户名，自动分词标志，显示模板标志，候选模板指针
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + this.auto_word_segment + "/" + this.passWord +  "--" + m_user_host_serial_number + "--" + m_user_host_ip_address + "=" + sentence_num + "#" + "0" + "%" + this.comment + "&" + dateTimeData;  
			//句子内容
			var send_data={
			      //发送加载句子的参数
                  id:selectMark,
				  option:option_data,//
                  data:test_sentence //
            };
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){
			  //按编号返回的数据
              var lineData = res.data;				 
			  //得到数据头
              var strDataHead = lineData.substring(0,lineData.indexOf("|||"))
              //剩余数据
              lineData  = lineData.substring(lineData.indexOf("|||") + 3,lineData.length)
			  //得到库名
			  var bank_name = strDataHead.substring(strDataHead.indexOf("bank:") + "bank:".length,strDataHead.indexOf(" section:"))
			  //得到区名
			  var section_name = strDataHead.substring(strDataHead.indexOf(" section:") + " section:".length,strDataHead.indexOf(" number:"))
			  //得到编号
			  var object_number = strDataHead.substring(strDataHead.indexOf(" number:") + " number:".length,strDataHead.length)
			  var currentPointer = object_number.substring(0,object_number.indexOf("/"))
			  var TotalCount = object_number.substring(object_number.indexOf("/")+1,object_number.length)
			  //显示库名
//			  this.bank_name = bank_name
			  //显示区名
//			  this.section_name = section_name
			  //显示编号数据
			  this.sentence_number_in_sentencebank = object_number
			  
			  //当前指针是在范围内?
			  if (Number(currentPointer) <= Number(TotalCount)){
				  //显示句库中句子信息
				  this.input_sentence = lineData;
			  }
			  else if (Number(currentPointer) > 10000){
				 //显示错误
				 alert("错误，当前指定的编号：" + currentPointer + "，超过最大有效范围：" + "10000句！" )
			  }
			  else{
				 //显示错误
				 alert("错误，当前指定的编号：" + currentPointer + "，超过当前句库中的句子总数：" + TotalCount )
			  }
			},function(res){
			    //显示错误
			    alert(res.status)
			});
		},
 		//跳转到FAQ库中上一句
		jump_last_sentence_number_in_faqbank: function(){
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}		    
			var sentence_num = this.sentence_number_in_faqbank;
			//有分割符?
		    if (sentence_num.indexOf("/") != -1){
			     //得到纯编号
			     sentence_num = sentence_num.substring(0,sentence_num.indexOf("/"))
			}
			var intNumber = Number(sentence_num)
			//指针减一
			if (intNumber > 1){
			   intNumber = intNumber -1
			}else {
			   alert("警告！当前已经是最前的一个句子。")
			}
			//更新当前值
			this.sentence_number_in_faqbank = String(intNumber)
			//重新调用
			this.jump_now_sentence_number_in_faqbank()
		},
		//跳转到FAQ库中下一句
		jump_next_sentence_number_in_faqbank: function(){
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}		    
			var sentence_num = this.sentence_number_in_faqbank;
			//有分割符?
		    if (sentence_num.indexOf("/") != -1){
			     //得到纯编号
			     sentence_num = sentence_num.substring(0,sentence_num.indexOf("/"))
			}
			var intNumber = Number(sentence_num)
			//指针加一
			if (intNumber < 10000){
			   intNumber = intNumber +1
			}else {
			   alert("警告！当前已经是最后的一个句子。(目前暂设置最多10000个句子实验)")
			}
			//更新当前值
			this.sentence_number_in_faqbank = String(intNumber)
			//重新调用
			this.jump_now_sentence_number_in_faqbank()
		},
		//跳转到跳转到FAQ库中指定编号的句子
		jump_now_sentence_number_in_faqbank: function(){
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}			
			var sentence_num = this.sentence_number_in_faqbank;
			//有分割符?
		    if (sentence_num.indexOf("/") != -1){
			     //得到纯编号
			     sentence_num = sentence_num.substring(0,sentence_num.indexOf("/"))
			}
			var intNumber = Number(sentence_num)
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_parse_url;
			}else{
				use_IP_url = this.local_parse_url;
			}
			//当前时间
			var dateTimeData = new Date();
			//只显示句库中句子，不显示模板内容
			//this.check_show_template = false;
		    //选择句库标志
		    var selectMark;
		   //建立选择句库句分析标志
			selectMark = "LoadSenteceInFaqBank"
			//备注内容
			this.comment = "0"
			//句子内容
			var test_sentence = "?"
			//建立库名,区名,用户名，自动分词标志，显示模板标志，候选模板指针
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + this.auto_word_segment + "/" + this.passWord +  "--" + m_user_host_serial_number + "--" + m_user_host_ip_address + "=" + sentence_num + "#" + "0" + "%" + this.comment + "&" + dateTimeData;  
			//句子内容
			var send_data={
			      //发送加载句子的参数
                  id:selectMark,
				  option:option_data,//
                  data:test_sentence //
            };
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){
			  //按编号返回的数据
              var lineData = res.data;				 
			  //得到数据头
              var strDataHead = lineData.substring(0,lineData.indexOf("|||"))
              //剩余数据
              lineData  = lineData.substring(lineData.indexOf("|||") + 3,lineData.length)
			  //得到库名
			  var bank_name = strDataHead.substring(strDataHead.indexOf("bank:") + "bank:".length,strDataHead.indexOf(" section:"))
			  //得到区名
			  var section_name = strDataHead.substring(strDataHead.indexOf(" section:") + " section:".length,strDataHead.indexOf(" number:"))
			  //得到编号
			  var object_number = strDataHead.substring(strDataHead.indexOf(" number:") + " number:".length,strDataHead.length)
			  var currentPointer = object_number.substring(0,object_number.indexOf("/"))
			  var TotalCount = object_number.substring(object_number.indexOf("/")+1,object_number.length)
			  //显示库名
//			  this.bank_name = bank_name
			  //显示区名
//			  this.section_name = section_name
			  //显示编号数据
			  this.sentence_number_in_faqbank = object_number
			  
			  //当前指针是在范围内?
			  if (Number(currentPointer) <= Number(TotalCount)){

				 //显示FAQ信息
				 this.DisplayFAQContent(lineData);				 

				 ///显示回应信息
				 this.output_understanding = strResponse;
			  }
			  else if (Number(currentPointer) > 10000){
				 //显示错误
				 alert("错误，当前指定的编号：" + currentPointer + "，超过最大有效范围：" + "10000句！" )
			  }
			  else{
				 //显示错误
				 alert("错误，当前指定的编号：" + currentPointer + "，超过当前句库中的句子总数：" + TotalCount )
			  }
			},function(res){
			 //显示错误
			 alert(res.status)
			});
		},
		//显示FAQ信息
		DisplayFAQContent:function(faq_content){
			  var strQuestion = "";
			  var strAnswer = "";
			  var strAction = "";
			  var strMeaning = "";
			  if (faq_content.indexOf("|||") != -1){
				 //得到句子内容 
				 strQuestion = faq_content.substring(0,faq_content.indexOf("|||"));
				 faq_content = faq_content.substring(faq_content.indexOf("|||") + 3,faq_content.length);
			  }else{
				 strQuestion = faq_content;
			  }
			  //显示句库中回答信息
			  if (faq_content.indexOf("|||") != -1){
				 //得到回答内容 
				 strAnswer = faq_content.substring(0,faq_content.indexOf("|||"));
				 faq_content = faq_content.substring(faq_content.indexOf("|||") + 3,faq_content.length);
			  }
			  //显示句库中动作信息
			  if (faq_content.indexOf("|||") != -1){
				 //得到动作内容 
				 strAction = faq_content.substring(0,faq_content.indexOf("|||"));
				 faq_content = faq_content.substring(faq_content.indexOf("|||") + 3,faq_content.length);
				 //得到意图内容 
				 strMeaning = faq_content;
			  }
			 //建立问题句子对应的信息
			// var strResponse = "---回答------- " + strAnswer + "\r\n" + "---动作------- " + strAction + "\r\n" + "---意图------- " + //strMeaning + "\r\n" 
			
			/////显示问题句子
			this.faq_question = strQuestion;
			//显示回答
			this.faq_answer = strAnswer;
			//显示动作
			this.faq_action = strAction;
			//显示意图
			this.faq_meaning = strMeaning;
		},
		//管理用户机器人信息
		jump_now_sentence_number_in_faqbank: function(){
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}			
			var sentence_num = this.sentence_number_in_faqbank;
			//有分割符?
		    if (sentence_num.indexOf("/") != -1){
			     //得到纯编号
			     sentence_num = sentence_num.substring(0,sentence_num.indexOf("/"))
			}
			var intNumber = Number(sentence_num)
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_parse_url;
			}else{
				use_IP_url = this.local_parse_url;
			}
			//当前时间
			var dateTimeData = new Date();
			//只显示句库中句子，不显示模板内容
			//this.check_show_template = false;
		    //选择句库标志
		    var selectMark;
		   //建立选择句库句分析标志
			selectMark = "LoadSenteceInFaqBank"
			//备注内容
			this.comment = "0"
			//句子内容
			var test_sentence = "?"
			//建立库名,区名,用户名，自动分词标志，显示模板标志，候选模板指针
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + this.auto_word_segment + "/" + this.passWord +  "--" + m_user_host_serial_number + "--" + m_user_host_ip_address + "=" + sentence_num + "#" + "0" + "%" + this.comment + "&" + dateTimeData;  
			//句子内容
			var send_data={
			      //发送加载句子的参数
                  id:selectMark,
				  option:option_data,//
                  data:test_sentence //
            };
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){
			  //按编号返回的数据
              var lineData = res.data;				 
			  //得到数据头
              var strDataHead = lineData.substring(0,lineData.indexOf("|||"))
              //剩余数据
              lineData  = lineData.substring(lineData.indexOf("|||") + 3,lineData.length)
			  //得到库名
			  var bank_name = strDataHead.substring(strDataHead.indexOf("bank:") + "bank:".length,strDataHead.indexOf(" section:"))
			  //得到区名
			  var section_name = strDataHead.substring(strDataHead.indexOf(" section:") + " section:".length,strDataHead.indexOf(" number:"))
			  //得到编号
			  var object_number = strDataHead.substring(strDataHead.indexOf(" number:") + " number:".length,strDataHead.length)
			  var currentPointer = object_number.substring(0,object_number.indexOf("/"))
			  var TotalCount = object_number.substring(object_number.indexOf("/")+1,object_number.length)
			  //显示库名
//			  this.bank_name = bank_name
			  //显示区名
//			  this.section_name = section_name
			  //显示编号数据
			  this.sentence_number_in_faqbank = object_number
			  
			  //当前指针是在范围内?
			  if (Number(currentPointer) <= Number(TotalCount)){

				 //显示FAQ信息
				 this.DisplayFAQContent(lineData);				 

				 ///显示回应信息
				 this.output_understanding = strResponse;
			  }
			  else if (Number(currentPointer) > 10000){
				 //显示错误
				 alert("错误，当前指定的编号：" + currentPointer + "，超过最大有效范围：" + "10000句！" )
			  }
			  else{
				 //显示错误
				 alert("错误，当前指定的编号：" + currentPointer + "，超过当前句库中的句子总数：" + TotalCount )
			  }
			},function(res){
			 //显示错误
			 alert(res.status)
			});
		},

		//检查格式是否正确
		CheckDataFormat: function(test_sentence){
			var m_phone_number;
			var m_verified_code;
			var m_password;
            var m_user_host_serial_number;
			var m_user_host_ip_address;
			var m_user_server_ip_address;

			if (test_sentence.indexOf("|||") == -1){
			    alert("错误，”电话号“之后缺少正确的格式符“|||”,请使用”电话号码|||验证码|||用户密码|||本机序列号|||用户本机IP地址|||用户服务器IP地址“格式进行数据输入！");
			    return false;
			}
			m_phone_number = test_sentence.substring(0,test_sentence.indexOf("|||"));
			test_sentence = test_sentence.substring(test_sentence.indexOf("|||") + 3,test_sentence.length);
			if (test_sentence.indexOf("|||") == -1){
			    alert("错误，”验证码“之后缺少正确的格式符“|||”,请使用”电话号码|||验证码|||用户密码|||本机序列号|||用户本机IP地址|||用户服务器IP地址“格式进行数据输入！");
			    return false;
			}
			m_verified_code = test_sentence.substring(0,test_sentence.indexOf("|||"));
			test_sentence = test_sentence.substring(test_sentence.indexOf("|||") + 3,test_sentence.length);			
			if (test_sentence.indexOf("|||") == -1){
			    alert("错误，”用户密码“之后缺少正确的格式符“|||”,请使用”电话号码|||验证码|||用户密码|||本机序列号|||用户本机IP地址|||用户服务器IP地址“格式进行数据输入！");
			    return false;
			}
			m_password = test_sentence.substring(0,test_sentence.indexOf("|||"));
			test_sentence = test_sentence.substring(test_sentence.indexOf("|||") + 3,test_sentence.length);	
			if (test_sentence.indexOf("|||") == -1){
			    alert("错误，”用户主机序列号“之后缺少正确的格式符“|||”,请使用”电话号码|||验证码|||用户密码|||本机序列号|||用户本机IP地址|||用户服务器IP地址“格式进行数据输入！");
			    return false;
			}
			m_user_host_serial_number = test_sentence.substring(0,test_sentence.indexOf("|||"));
			test_sentence = test_sentence.substring(test_sentence.indexOf("|||") + 3,test_sentence.length);			
			if (test_sentence.indexOf("|||") == -1){
			    alert("错误，”用户主机IP“之后缺少正确的格式符“|||”,请使用”电话号码|||验证码|||用户密码|||本机序列号|||用户本机IP地址|||用户服务器IP地址“格式进行数据输入！");
			    return false;
			}
			m_user_host_ip_address = test_sentence.substring(0,test_sentence.indexOf("|||"));
			test_sentence = test_sentence.substring(test_sentence.indexOf("|||") + 3,test_sentence.length);			
			m_user_server_ip_address = test_sentence;
			return true;
		},
		//发送手机验证码
		phone_verified_code: function(){	
		    //判断是否登录成功
		    if(this.login_mark != true){
//				alert("请先登录成功再操作！");
//				return
			}			
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_parse_url;
			}else{
				use_IP_url = this.local_parse_url;
			}
		    var selectMark = "PhoneVerifiedCode" //发送验证码标志
			//当前时间
			var dateTimeData = new Date();
			//备注内容
			this.comment = "0"
			this.bank_name = "";//空的用户库名
			//建立库名,区名,用户名，自动分词标志，显示模板标志，候选模板指针
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + this.auto_word_segment + "/" + this.passWord +  "--" + m_user_host_serial_number + "--" + m_user_host_ip_address + "=" + "0" + "#" + "0" + "%" + this.comment + "&" + dateTimeData;  
			//电话号码 验证码 本机序列号 Ip地址 
		    var test_sentence = this.input_sentence;
			//检查格式是否正确
			if (this.CheckDataFormat(test_sentence) == false){
			   alert("错误，格式不正确，请按正确填写数据！");
			   return;
			}

			var send_data={
			      //发送测试句子
                  id:selectMark,
				  option:option_data,//建立选择库,句子编号,自动分词标志
                  data:test_sentence //句子内容
            };
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){
				if (res.data.indexOf("OK") == 0){
				   alert("OK，用户手机验证码发送成功！" + res.data);
				}else {
				   alert("错误，本次用户手机验证码发送失败！" + res.data);
				}
			},function(res){
			 //显示错误
			 alert(res.status)
			});
		},
		//用户注册
		register: function(){	
		    //判断是否登录成功
		    if(this.login_mark != true){
//				alert("请先登录成功再操作！");
//				return
			}			
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_parse_url;
			}else{
				use_IP_url = this.local_parse_url;
			}
		    var selectMark = "Register" //注册标志
			//当前时间
			var dateTimeData = new Date();
			//备注内容
			this.comment = "0"
		    //选择句库标志
		    var m_user_name;
			var m_password;
			var m_user_host_serial_number;
			var m_user_host_ip_address;
			var m_verfied_code;
		   //判断是否正确的用户注册
			this.bank_name = "";//空的用户库名
			//建立库名,区名,用户名，自动分词标志，显示模板标志，候选模板指针
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + this.auto_word_segment + "/" + this.passWord +  "--" + m_user_host_serial_number + "--" + m_user_host_ip_address + "=" + "0" + "#" + "0" + "%" + this.comment + "&" + dateTimeData;  
			//电话号码 验证码 本机序列号 Ip地址 
		    var test_sentence = this.input_sentence;
		    //检查格式是否正确
			if (this.CheckDataFormat(test_sentence) == false){
			   alert("错误，格式不正确，请按正确填写数据！");
			   return;
			}

			var send_data={
			      //发送测试句子
                  id:selectMark,
				  option:option_data,//建立选择库,句子编号,自动分词标志
                  data:test_sentence //句子内容
            };
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){
				if (res.data.indexOf("OK") == 0){
				   alert("OK，用户注册成功！" + res.data);
				}else {
				   alert("错误，本次注册失败！" + res.data);
				}
			},function(res){
			 //显示错误
			 alert(res.status)
			});
		},
		//用户修改密码
		change_password: function(){	
		    //判断是否登录成功
		    if(this.login_mark != true){
//				alert("请先登录成功再操作！");
//				return
			}			
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_parse_url;
			}else{
				use_IP_url = this.local_parse_url;
			}
		    var selectMark = "ChangePassword" //修改密码标志
			//当前时间
			var dateTimeData = new Date();
			//备注内容
			this.comment = "0"
		    //选择句库标志
		   //判断是否正确的用户注册
			this.bank_name = "";//空的用户库名
			//建立库名,区名,用户名，自动分词标志，显示模板标志，候选模板指针
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + this.auto_word_segment + "/" + this.passWord +  "--" + m_user_host_serial_number + "--" + m_user_host_ip_address + "=" + "0" + "#" + "0" + "%" + this.comment + "&" + dateTimeData;  
			//电话号码 验证码 本机序列号 Ip地址 
		    var test_sentence = this.input_sentence;
		    //检查格式是否正确
			if (this.CheckDataFormat(test_sentence) == false){
			   alert("错误，格式不正确，请按正确填写数据！");
			   return;
			}

			var send_data={
			      //发送测试句子
                  id:selectMark,
				  option:option_data,//建立选择库,句子编号,自动分词标志
                  data:test_sentence //句子内容
            };
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){
				if (res.data.indexOf("OK") == 0){
				   alert("OK，用户修改账号密码成功！" + res.data);
				}else {
				   alert("错误，本次修改账号密码失败！" + res.data);
				}
			},function(res){
			 //显示错误
			 alert(res.status)
			});
		},
		//用户登录
		login: function(){	
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_parse_url;
			}else{
				use_IP_url = this.local_parse_url;
			}
		    var selectMark = "Login" //登陆标志
			//当前时间
			var dateTimeData = new Date();
			//备注内容
			this.comment = "0"
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
		    //选择句库标志
			var bankName = this.bank_name;
			//检查句库格式是否正确？
			if (bankName.indexOf("Bank") != 0){//是正确的Bank开头？
			   alert("请使用Bank开头作为“库名”！");
			   return;
			}
			bankName = bankName.substring(bankName.indexOf("Bank") + "Bank".length,bankName.length);
			if (this.isNumber(bankName) != true){//是正确的数字内容？
			   alert("错误，当前的库编号" + bankName + "不是数字，请使用已申请的库编号数字” -BankX！");
			   return;
			}
		    //选择工作区标志
			var workSectionName = this.section_name.replace("*","");
			//检查工作区格式是否正确？
			if (workSectionName.indexOf("WorkSection") != 0){//是正确的WorkSection开头？
			   alert("请使用WorkSection开头作为“工作区名”！");
			   return;
			}
			workSectionName = workSectionName.substring(workSectionName.indexOf("WorkSection") + "WorkSection".length,workSectionName.length);
			if (this.isNumber(workSectionName) != true){//是正确的数字内容？
			   alert("错误，当前的工作区编号" + workSectionName + "不是数字，请使用已申请的工作区编号数字” -WorkSectionX！");
			   return;
			}
			//建立库名,区名,用户名，自动分词标志，显示模板标志，候选模板指针
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + this.auto_word_segment + "/" + this.passWord +  "--" + m_user_host_serial_number + "--" + m_user_host_ip_address + "=" + "0" + "#" + "0" + "%" + this.comment + "&" + dateTimeData;  
			//句子内容
		    var test_sentence = "";
			var send_data={
			      //发送测试句子
                  id:selectMark,
				  option:option_data,//建立选择库,句子编号,自动分词标志
                  data:test_sentence //句子内容
            };
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){
				if (res.data.indexOf("OK") == 0 ||res.data.indexOf("OK, the information is verified by router") != -1){//是OK 结果？
				   this.login_mark = true;
				   //按钮显示设置-- 正常显示
				   this.showButton_get_user_expired_time = true
				   this.showButton_admin_user_using_time = true
				   this.showButton_update_resource_parameter = true
				   this.showButton_update_resource_access_code = true  
				   this.showButton_watch_resource_access_code = true	
			       this.showButton_add_resource_access_code = true	
                   this.showButton_create_active_code = true
				   this.showButton_send_message = true
				   alert("OK，用户登录成功！");
				   
				}else if(res.data.indexOf("more than 10 errors") != -1){
				   alert("错误，用户登录失败超10次，请改天登录！");
				   this.login_mark = false;
				}else{
				
				  ///////////////2024.9.23 临时调整，路由不用连接对应主机，只要路由本地密码通过，也是登录成功 OK ///////////////////
				  
				   if (res.data.indexOf("the current host information is verified") != -1 && this.user_name.length == 11 && this.user_name.indexOf("180") == 0){//2024.11.24,增加手机编号长度180账号
					   this.login_mark = true;
					   //按钮显示设置-- 正常显示
					   this.showButton_get_user_expired_time = true
					   this.showButton_admin_user_using_time = true
					   this.showButton_update_resource_parameter = true
					   this.showButton_update_resource_access_code = true  
					   this.showButton_watch_resource_access_code = true
					   this.showButton_add_resource_access_code = true					   
					   alert("OK，用户登录成功！");
				   }
				   else{
					   alert("错误，用户登录失败！" + res.data);
					   this.login_mark = false;
				   }				}
			},function(res){
			 //显示错误
			 alert(res.status)
			});
			
		  },
		  //在向标注平台写数据时，使用网址wwww.gototree.com ，用户手机号登录 --与微信号登录
		  GetUserTokenFromLabelingPlatform: function() {
			  
			 if(this.weixin_number.substring(this.weixin_number.indexOf("微信用户_")+"微信用户_".length,this.weixin_number.length).trim() == ""){
				alert("请先输入有效的微信登录编号！");
				return;
			 }
			 if(this.passWord == null){
				alert("请先输入有效的密码！");
				return;
			 }
			 //得到用户请求JWT token
		     var strResult = "";
			 var URL = "https://www.gototree.com/app/user/pc_login?" + "&username=" + this.weixin_number.trim() + "&pass=" + this.passWord.trim();
			 this.$http.get(URL).then(function(res){
			 //得到请求结果
			 strResult = JSON.stringify(res.data)
			 if (strResult.indexOf("\"message\":\"操作成功\"") != -1)//is login successfully ?
			 {
				//得到JWT token
				this.jwt_token = strResult.substring(strResult.indexOf("\"jwt_token\":\"") + "\"jwt_token\":\"".length, strResult.indexOf("\"}"));
			}else{
				bolAccessMark = false;
				return ;
			}
			console.log('得到JWT token，' + '请求成功处理');  
 
			},function(res){
				console.log('得到JWT token，' + '请求失败处理',res);
			});
		},
		//得到用户库区ID
        GetUserBankAndWorkSectionIDFromLabelingPlatform:function(){
			var strResult = "";
		    //得到库区的列表
			var URL = "https://www.gototree.com/app/user/bank_list?" + "&jwt_token=" + this.jwt_token;
			//得到请求结果
			this.$http.get(URL).then(function(res){
				//得到请求结果
				strResult = JSON.stringify(res.data);
				// 建立库区列表
				this.GetBankAndSectionList(strResult);
				//得到当前库区ID
			    this.GetBankIDAndWorkSectionIDByCurrentBankNameAndWorkSectionName();
				console.log("得到用户库区ID，" +'请求成功处理');   
                
			},function(res){
				console.log('得到用户库区ID，' + '请求失败处理',res);
			});
		},
		//得到用户当前选择的领域ID
		GetUserSelectedDomainIDFromLabelingPlatform:function(){
			var strResult = "";
		  	//得到用户选定的当前领域
			var URL = "https://www.gototree.com/app/user/index?" + "&bank_id=" + this.userBank_ID + "&section_id=" + this.userWorkSection_ID + "&jwt_token=" + this.jwt_token;
			//得到请求结果
			this.$http.get(URL).then(function(res){
				//得到请求结果
				strResult = JSON.stringify(res.data);
				this.userSelectedDomain_ID = strResult.substring(strResult.indexOf("\"selectDomainId\":\"") + "\"selectDomainId\":\"".length, strResult.length);

				this.userSelectedDomain_ID = this.userSelectedDomain_ID.substring(0,this.userSelectedDomain_ID.indexOf("\","));
				console.log("得到用户领域，" + '请求成功处理');   
			},function(res){
				console.log("得到用户领域，" + '请求失败处理',res);
			});
        },
        //得到用户库和区的列表,得到库区的ID
        GetBankAndSectionList:function(strResult){
			
            if(strResult == ""){
                return;
            }
			if(strResult.indexOf("\"data\":[") == -1){
                return;
			}
			//建立库区的列表
			var strBankAndSectionNameIDArray = new Array();
			var intBankCount = 0;
            var intBankPointer = 1;
            var intSectionPointer = 0;
            var strUnit = "";
            var strID = "";
            var strTitle = "";
            var strSectionContentInOneBank = "";
            var strBankNamePart = strResult.substring(strResult.indexOf("\"data\":[") + "\"data\":[".length, strResult.indexOf("]"));//
            strResult = strResult.substring(strResult.indexOf("[") + "[".length, strResult.lastIndexOf("]"));//
            strResult = strResult.substring(strResult.indexOf("]") + 1, strResult.length);//the rest
            var strSectionNamePart = strResult.substring(strResult.indexOf("[") + "[".length, strResult.lastIndexOf("]"));//

            //建立库名数组
            while (strBankNamePart.indexOf("{") != -1)
            {
                strUnit = strBankNamePart.substring(strBankNamePart.indexOf("{") + "{".length, strBankNamePart.indexOf("}"));//
                strBankNamePart = strBankNamePart.substring(strBankNamePart.indexOf("}") + 1, strBankNamePart.length);//the rest
               strID = strUnit.substring(strUnit.indexOf("\"id\":") + "\"id\":".length, strUnit.indexOf(","));//
                strID = strID.replace(/\"/g, '');//
                strUnit = strUnit.substring(strUnit.indexOf(",") + 1, strUnit.length);//the rest
                strTitle = strUnit.substring(strUnit.indexOf("\"title\":") + "\"title\":".length, strUnit.length);//
                strTitle = strTitle.replace(/\"/g, '');//
				strBankAndSectionNameIDArray[intBankPointer]= new Array();
				strBankAndSectionNameIDArray[intBankPointer][0]= new Array();
                strBankAndSectionNameIDArray[intBankPointer][0][1] = strID;
                strBankAndSectionNameIDArray[intBankPointer][0][2] = strTitle;
				intBankPointer++;
            }
            //建立库名称的数量
            intBankCount = intBankPointer - 1;
            //建立库对应的区名称
            intBankPointer = 1;
            while (strSectionNamePart.indexOf("[") != -1)
            {
                //得到一个库包含的区内容
                strSectionContentInOneBank = strSectionNamePart.substring(strSectionNamePart.indexOf("[") + 1, strSectionNamePart.indexOf("]"));
                strSectionNamePart = strSectionNamePart.substring(strSectionNamePart.indexOf("]") + 1, strSectionNamePart.length);//the rest
                //建立工作区名数组
                intSectionPointer = 1;
                while (strSectionContentInOneBank.indexOf("{") != -1)
                {
                    strUnit = strSectionContentInOneBank.substring(strSectionContentInOneBank.indexOf("{") + "{".length, strSectionContentInOneBank.indexOf("}"));//
                    strSectionContentInOneBank = strSectionContentInOneBank.substring(strSectionContentInOneBank.indexOf("}") + 1, strSectionContentInOneBank.length);//the rest
                    strID = strUnit.substring(strUnit.indexOf("\"id\":") + "\"id\":".length, strUnit.indexOf(","));//
                    strID = strID.replace(/\"/g, '');//
                    strUnit = strUnit.substring(strUnit.indexOf(",") + 1, strUnit.length);//the rest
                    strTitle = strUnit.substring(strUnit.indexOf("\"title\":") + "\"title\":".length, strUnit.length);//
                    strTitle = strTitle.replace(/\"/g, '');//
			  	    strBankAndSectionNameIDArray[intBankPointer][intSectionPointer]= new Array();strBankAndSectionNameIDArray[intBankPointer][intSectionPointer][1] = strID;
                    strBankAndSectionNameIDArray[intBankPointer][intSectionPointer][2] = strTitle;
				    intSectionPointer++;
                }
                //建立一个库的工作区名称的数量
                strBankAndSectionNameIDArray[intBankPointer][0][0] = String(intSectionPointer - 1);
                //下一个库指针
                intBankPointer++;
            }
			
			//得到当前库区ID
			var bolCheckMark = false;
			var strTempBankName = "";
			var strTempSectionName = "";
			this.userBank_ID = "-1";
			this.userWorkSection_ID = "-1";
			intBankPointer = 1;
			while (intBankPointer <= intBankCount && bolCheckMark == false){
				//得到库名			
				strTempBankName = strBankAndSectionNameIDArray[intBankPointer][0][2];
				if(strTempBankName == this.bank_name)//是相同的库名？
				{
					//得到库ID
					this.userBank_ID = strBankAndSectionNameIDArray[intBankPointer][0][1];
					var intSectionCount = parseInt(strBankAndSectionNameIDArray[intBankPointer][0][0]);
					intSectionPointer = 1;
					while (intSectionPointer <= intSectionCount  && bolCheckMark == false){
						//得到工作区名
						strTempSectionName = strBankAndSectionNameIDArray[intBankPointer][intSectionPointer][2];
						if(strTempSectionName == this.section_name)//相同的区名？
						{
							//得到工作区ID
							this.userWorkSection_ID = strBankAndSectionNameIDArray[intBankPointer][intSectionPointer][1];
							//建立找到标志
							bolCheckMark = true;
							break;
						}
						intSectionPointer++;
				    }
				}
				intBankPointer++;
			}
        },
		//延迟的方法
		   sleep(numberMillis){    
			var now = new Date();    
			var exitTime = now.getTime() + numberMillis;   
			while (true) { 
			  now = new Date();       
			  if (now.getTime() > exitTime) return;
			}     
		},
		//跳转当前编号的模板
		jump_now_sentence_number_of_template: function(){	
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
			var inner_sentence_number_of_template = this.sentence_number_of_template;
			//有分割符?
		    if (inner_sentence_number_of_template.indexOf("/") != -1){
			     //得到纯编号
			     inner_sentence_number_of_template = inner_sentence_number_of_template.substring(0,inner_sentence_number_of_template.indexOf("/"))
			}
			var intNumber = Number(inner_sentence_number_of_template)
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_parse_url;
			}else{
				use_IP_url = this.local_parse_url;
			}
			//当前时间
			var dateTimeData = new Date();
			//只显示模板内容
			//this.check_show_template = true;
		    //选择模板标志
		    var selectMark;
		   //建立显示模板标志
			selectMark = "LoadTemplateBySentenceNumberInSection"
			//模板的句子内容
			var template_sentence = "?"
			//建立库名,区名,用户名，自动分词标志，显示模板标志，候选模板指针
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + this.auto_word_segment + "/" + this.passWord +  "--" + m_user_host_serial_number + "--" + m_user_host_ip_address + "=" + inner_sentence_number_of_template + "#" + "0" + "%" + this.comment + "&" + dateTimeData;  
			//句子内容
			var send_data={
			      //发送加载句子的参数
                  id:selectMark,
				  option:option_data,//
                  data:template_sentence //
            };
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){
			  //按编号返回的数据
              var lineData = res.data;	
			  //得到理解的结果
			  var strUnderstoodResult = "";
			  if (lineData.indexOf(">>>") != -1){//有机器理解的结果？
					strUnderstoodResult = lineData.substring(lineData.indexOf(">>>") + ">>>".length,lineData.length)
					lineData = lineData.substring(0,lineData.indexOf(">>>"));
			  }
			  //得到数据头
              var strDataHead = lineData.substring(0,lineData.indexOf("|||"))
			  //显示头数据
			  this.sentence_number_of_template = strDataHead
              //剩余数据
			  lineData  = lineData.substring(lineData.indexOf("|||") + 3,lineData.length)			  
			  //得到库名
			  var bank_name = strDataHead.substring(strDataHead.indexOf("bank:") + "bank:".length,strDataHead.indexOf(" section:"))
			  //得到区名
			  var section_name = strDataHead.substring(strDataHead.indexOf(" section:") + " section:".length,strDataHead.indexOf(" number:"))
			  //得到编号
			  var object_number = strDataHead.substring(strDataHead.indexOf(" number:") + " number:".length,strDataHead.indexOf(" score:"))
			  var currentPointer = object_number.substring(0,object_number.indexOf("/"))
			  var TotalCount = object_number.substring(object_number.indexOf("/")+1,object_number.length)
			  var score = strDataHead.substring(strDataHead.indexOf(" score:") + " score:".length,strDataHead.indexOf(" template:"))
			  this.match_score = score
			  var template_ID = strDataHead.substring(strDataHead.indexOf(" template:") + " template:".length,strDataHead.indexOf(" ip:"))
			  this.matched_template_id = template_ID
		      //显示库名
//			  this.bank_name = bank_name
			  //显示区名
//			  this.section_name = section_name
			  //显示编号数据
			  this.sentence_number_of_template = object_number
			  //当前指针是在范围内?
			  if (Number(currentPointer) <= Number(TotalCount)){
				  //显示区内模板库中模板信息
				  this.ShowAllInformationForTemplateInBank(lineData)
				  ///输出机器理解的结果
				  if (this.check_simply_show == true){//是简化显示?
					 strUnderstoodResult = this.SimplyShowUnderstoodResult(strUnderstoodResult)
				  }
				  this.output_understanding = strUnderstoodResult
			  }
			  else{
				  //显示错误
				  alert("错误，当前指定的编号：" + currentPointer + "，超过最大有效范围：" + TotalCount )
			  }
			},function(res){
			  //显示错误
			  alert(res.status)
			});
		},
		//跳转前一个编号模板
		jump_last_sentence_number_of_template: function(){	
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
			var inner_sentence_number_of_template = this.sentence_number_of_template;
			//有分割符?
		    if (inner_sentence_number_of_template.indexOf("/") != -1){
			     //得到纯编号
			     inner_sentence_number_of_template = inner_sentence_number_of_template.substring(0,inner_sentence_number_of_template.indexOf("/"))
			}
			var intNumber = Number(inner_sentence_number_of_template)
			//指针减一
			if (intNumber > 1){
			   intNumber = intNumber -1
			}else {
			   alert("警告！当前已经是最前的一个句子。")
			}
			//更新当前值
			this.sentence_number_of_template = String(intNumber)
            //跳转指定编号模板
            this.jump_now_sentence_number_of_template()  			
		},
		//跳转下一个编号模板
		jump_next_sentence_number_of_template: function(){	
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
 			var inner_sentence_number_of_template = this.sentence_number_of_template;
			//有分割符?
		    if (inner_sentence_number_of_template.indexOf("/") != -1){
			     //得到纯编号
			     inner_sentence_number_of_template = inner_sentence_number_of_template.substring(0,inner_sentence_number_of_template.indexOf("/"))
			}
			var intNumber = Number(inner_sentence_number_of_template)
			//指针加一
			if (intNumber < 10000){
			   intNumber = intNumber +1
			}else {
			   alert("警告！当前已经是最后的一个句子。(目前暂设置最多10000个模板)")
			}
			//更新当前值
			this.sentence_number_of_template = String(intNumber)
            //跳转指定编号模板
            this.jump_now_sentence_number_of_template()  	
		},
		//跳转当前序号的Rank模板
		jump_now_rank_template: function(){	
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
			var temp_rank_template_pointer = this.template_number_on_rank;
			//有分割符?
		    if (temp_rank_template_pointer.indexOf("/") != -1){
			     //得到纯编号
			     temp_rank_template_pointer = temp_rank_template_pointer.substring(0,temp_rank_template_pointer.indexOf("/"))
			}
			var intNumber = Number(temp_rank_template_pointer)
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_parse_url;
			}else{
				use_IP_url = this.local_parse_url;
			}
			//当前时间
			var dateTimeData = new Date();
			//只显示模板内容
			//this.check_show_template = true;
		    //选择模板标志
		    var selectMark;
		   //建立显示模板标志
			selectMark = "LoadRankTemplate"
			//模板的句子内容
			var template_sentence = "?"
			//建立库名,区名,用户名，自动分词标志，显示模板标志，候选模板指针
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + this.auto_word_segment + "/" + this.passWord +  "--" + m_user_host_serial_number + "--" + m_user_host_ip_address + "=" + temp_rank_template_pointer + "#" + "0" + "%" + this.comment + "&" + dateTimeData;   
			//句子内容
			var send_data={
			      //发送加载句子的参数
                  id:selectMark,
				  option:option_data,//
                  data:template_sentence //
            };
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){
				  //按编号返回的数据
				  var lineData = res.data;
					if (lineData == null||lineData == ""){
					    alert("提示，当前选择区没有相关数据！")
					    return
					}				  
				  //得到数据头
				  var strDataHead = lineData.substring(0,lineData.indexOf("|||"))
                  //剩余数据
			      //得到理解的结果
			      var strUnderstoodResult = lineData.substring(lineData.indexOf(">>>") + ">>>".length,lineData.length)
			      lineData  = lineData.substring(lineData.indexOf("|||") + 3,lineData.indexOf(">>>"))			  
				  //显示头数据
				  this.template_number_on_rank = strDataHead
				  //得到库名
				  var bank_name = strDataHead.substring(strDataHead.indexOf("bank:") + "bank:".length,strDataHead.indexOf(" section:"))
				  //得到区名
				  var section_name = strDataHead.substring(strDataHead.indexOf(" section:") + " section:".length,strDataHead.indexOf(" number:"))
				  //得到编号
				  var object_number = strDataHead.substring(strDataHead.indexOf(" number:") + " number:".length,strDataHead.indexOf(" score:"))
				  var currentPointer = object_number.substring(0,object_number.indexOf("/"))
				  var TotalCount = object_number.substring(object_number.indexOf("/")+1,object_number.length)
				  //提取匹配得分
				  var score = strDataHead.substring(strDataHead.indexOf("score:") + "score:".length,strDataHead.indexOf("template:"))
				  this.match_score = score
				  //得到模板ID
				  var template_ID = strDataHead.substring(strDataHead.indexOf("template:") + "template:".length,strDataHead.indexOf("ip:"))
				  this.matched_template_id = template_ID

				  //显示库名
//				  this.bank_name = bank_name
				  //显示区名
//				  this.section_name = section_name
				  //显示编号数据
				  this.template_number_on_rank = object_number
				  //当前指针是在范围内?
				  if (Number(currentPointer) <= Number(TotalCount)){
					  //显示Rank模板信息
					  this.ShowAllInformationForTemplateInBank(lineData)
					  ///输出机器理解的结果
					  if (this.check_simply_show == true){//是简化显示?
					     strUnderstoodResult = this.SimplyShowUnderstoodResult(strUnderstoodResult)
					  }
					  this.output_understanding = strUnderstoodResult
				  }
				  else{
					  //显示错误
					  alert("错误，当前指定的编号：" + currentPointer + "，超过最大有效范围：" + TotalCount )
				  }
			  },function(res){
			  //显示错误
			  alert(res.status)
			});
		},
		//跳转前一个Rank模板
		jump_last_rank_template: function(){	
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
			var temp_rank_template_pointer = this.template_number_on_rank;
			//有分割符?
		    if (temp_rank_template_pointer.indexOf("/") != -1){
			     //得到纯编号
			     temp_rank_template_pointer = temp_rank_template_pointer.substring(0,temp_rank_template_pointer.indexOf("/"))
			}
			var intNumber = Number(temp_rank_template_pointer)
		    //判断候选模板指针是否越界
		    if(intNumber == 1){
			   alert("警告，当前已经是最前的一个候选模板！");
			}else{
			   //前一个候选模板指针
			   intNumber--;
			   //显示候选模板指针
               this.template_number_on_rank = String(intNumber) + '/10';
			   //跳转指定序号的Rank模板
		       this.jump_now_rank_template()
			}  		
		},
		//跳转下一个Rank模板
		jump_next_rank_template: function(){	
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
			var temp_rank_template_pointer = this.template_number_on_rank;
			//有分割符?
		    if (temp_rank_template_pointer.indexOf("/") != -1){
			     //得到纯编号
			     temp_rank_template_pointer = temp_rank_template_pointer.substring(0,temp_rank_template_pointer.indexOf("/"))
			}
			var intNumber = Number(temp_rank_template_pointer)
		    //判断候选模板指针是否越界
		    if(intNumber == 10){
			   alert("警告，当前已经是最后的一个候选模板！");
			}else{
			   //下一个候选模板指针
			   intNumber++;
			   //显示候选模板指针
               this.template_number_on_rank = String(intNumber) + '/10';
			   //跳转指定序号的Rank模板
		       this.jump_now_rank_template()
		   }  
		},
		//对句库中全部句子进行句法分析
		parse_all_sentence: function(){	
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_parse_url;
			}else{
				use_IP_url = this.local_parse_url;
			}
		    var selectMark = "All_Parse" //全库分析
			//当前时间
			var dateTimeData = new Date();
			//备注内容
			this.comment = "0"
			//建立库名,区名,用户名，自动分词标志，显示模板标志，候选模板指针
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + this.auto_word_segment + "/" + this.passWord +  "--" + m_user_host_serial_number + "--" + m_user_host_ip_address + "=" + this.candiate_template_number + "#" + this.sub_template_number + "%" + this.comment + "&" + dateTimeData;  
			//句子内容
		    var test_sentence = "";
			var send_data={
			      //发送测试句子
                  id:selectMark,
				  option:option_data,//建立选择库,句子编号,自动分词标志
                  data:test_sentence //句子内容
            };
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){
				 alert(res.data);
			},function(res){
			 //显示错误
			 alert(res.status)
			});
		},
		//得到输入句的答案行为体回应
		get_faq: function(){	
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_parse_url;
			}else{
				use_IP_url = this.local_parse_url;
			}
			//当前时间
			var dateTimeData = new Date();
		    //选择句库标志
		    var selectMark;
			var strParsedResult;
			var strUnderstoodResult;
		   //建立选择句库句分析标志
			selectMark = "Get_FAQ"
			//选择指定的句库
			//备注内容
			this.comment = "0"
			//建立库名,区名,用户名，自动分词标志，显示模板标志，候选模板指针
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + this.auto_word_segment + "/" + this.passWord +  "--" + m_user_host_serial_number + "--" + m_user_host_ip_address + "=" + this.candiate_template_number + "#" + this.sub_template_number + "%" + this.comment + "&" + dateTimeData;  
			//句子内容
		    var test_sentence = this.input_sentence;
			var send_data={
			      //发送测试句子
                  id:selectMark,
				  option:option_data,//建立选择库,句子编号,自动分词标志
                  data:test_sentence //句子内容
            };
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){

			//句法树数据
			if (res.data == "")//为空?
			{
			   //读取开机显示原始树
			    this.ShowInintializationParsedTree();
				alert("抱歉，当前分析失败，需要对当前的句子进行学习！")
				//清空结果文件
				this.parsed_result = ""
			    return
			}
		    //得到对句法树子信息解析的句法树
		//    this.get_tree_with_subinformation(res.data)
			//转换JSON格式句法树到括号型的句法树
		 	//strParsedResult = this.TranJSONSyntaxTreeToNormalFormat(JSON.stringify(res.data))
		console.log(res.data)
		  var lineData = res.data
		  //得到数据头
		  var strDataHead = lineData.substring(0,lineData.indexOf("|||"))
		  //剩余数据
		  lineData  = lineData.substring(lineData.indexOf("|||") + 3,lineData.length)
		  //得到库名
		  var bank_name = strDataHead.substring(strDataHead.indexOf("bank:") + "bank:".length,strDataHead.indexOf(" section:"))
		  //得到区名
		  var section_name = strDataHead.substring(strDataHead.indexOf(" section:") + " section:".length,strDataHead.indexOf(" number:"))

		  //得到编号
		  var object_number = strDataHead.substring(strDataHead.indexOf(" number:") + " number:".length,strDataHead.indexOf(" score:"))
		  var currentPointer = object_number.substring(0,object_number.indexOf("/"))
		  var TotalCount = object_number.substring(object_number.indexOf("/")+1,object_number.length)
		  //显示库名
//		  this.bank_name = bank_name
		  //显示区名
//		  this.section_name = section_name
		  //显示编号数据
		  this.sentence_number_of_template = object_number

			//提取匹配得分，模板ID，句法树 ////////2022.5.24修改，不用JSON,同时加了得分和模板ID输出功能
			var score = strDataHead.substring(strDataHead.indexOf(" score:") + " score:".length,strDataHead.indexOf(" template:"))
			this.match_score = score
		    strDataHead = strDataHead.substring(strDataHead.indexOf(" ") + 1,strDataHead.length)	
			var template_ID = strDataHead.substring(strDataHead.indexOf(" template:") + " template:".length,strDataHead.indexOf(" ip:"))
			this.matched_template_id = template_ID
			
			//显示FAQ信息
			this.DisplayFAQContent(lineData);
			//清输出结果的显示
            strParsedResult = ""
			this.output_understanding = strParsedResult;
		  });
        },
		//上传问题答案行为体
		send_faq: function(){	
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_learn_url;
			}else{
				use_IP_url = this.local_learn_url;
			}
			//当前时间
			var dateTimeData = new Date();
		    //选择句库标志
		    var selectMark;
			var strParsedResult;
			var strUnderstoodResult;
		   //建立选择句库句分析标志
			selectMark = "Send_FAQ"
			//选择指定的句库
			//备注内容
			this.comment = "0"
			//建立库名,区名,用户名，自动分词标志，显示模板标志，候选模板指针
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + this.auto_word_segment + "/" + this.passWord +  "--" + m_user_host_serial_number + "--" + m_user_host_ip_address + "=" + this.candiate_template_number + "#" + this.sub_template_number + "%" + this.comment + "&" + dateTimeData;  
			//内容
		    var test_sentence = this.input_sentence;
			var send_data={
			      //发送数据
                  id:selectMark,
				  option:option_data,//建立选择库,句子编号,自动分词标志
                  data:test_sentence //内容
            };
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){

			//接受数据
			if (res.data == ""||res.data.indexOf("OK") != 0)//为空或错误 ?
			{
			   //读取开机显示原始树
			    this.ShowInintializationParsedTree();
				alert("抱歉，当前上传问题答案行为体操作失败！")
				//清空结果文件
				this.parsed_result = ""
				this.output_understanding = res.data;
			    return
			}
			//在输出结果位置显示接受的数据
			this.output_understanding = res.data;
		  });
        },
		//远程上传FAQ到标注平台 ---真实用户使用（非远程FAQ只为软件功能测试使用-直接连接分析器服务器而不是标注平台）
		remote_send_faq: function(){
			/////登录标注平台/////
            if(this.bolLabelingPlatformLoginMark == false)//标注平台登录成功？
			{
				if (this.jwt_token == "" || this.jwt_token == null)
				{
					//得到用户JWT token
					this.GetUserTokenFromLabelingPlatform();
					this.sleep(100)	
					return;					
				}
				if(this.userBank_ID == "" ||this.userBank_ID == "-1"){
					//得到用户库区ID
					this.GetUserBankAndWorkSectionIDFromLabelingPlatform();			
					this.sleep(100)	
					return;							
				}
				if(this.userWorkSection_ID == ""||this.userWorkSection_ID == "-1"){
					//得到用户当前选择的领域ID
					this.GetUserSelectedDomainIDFromLabelingPlatform();
					this.sleep(100)		
					return;							
				}
				if(this.userBank_ID != "" && this.userBank_ID != "-1" && this.userWorkSection_ID != "" && this.userWorkSection_ID != "-1" && this.userSelectedDomain_ID != "" &&this.userSelectedDomain_ID != "-1"){
					alert("OK！标注平台登录成功！");
					//建立登录成功标志
					this.bolLabelingPlatformLoginMark = true;
		     //       alert(this.userBank_ID + "-" + this.userWorkSection_ID + "-" + this.userSelectedDomain_ID)
				}else{
					alert("错误！标注平台登录失败！请尝试多次登录操作！");
				  return;
				}
			}
            if (this.faq_answer == "" && this.faq_action == "" && this.faq_meaning == "")//是空的FAQ？
            {
                alert("提示，当前FAQ“回答”，“动作”，“意图”都为空，请确定是FAQ而不是标注句子上传！如果空内容FAQ上传，请填写“待标”后再上传。");
                return;
            }
            var strQuestion = this.faq_question;
            var strAnswer = this.faq_answer;
            var strAction = this.faq_action;
            var strMeaning = this.faq_meaning;
            var strFAQ = strQuestion + "|||" + strAnswer + "|||" + strAction + "|||" + strMeaning;
			var strData = "{\"jwt_token\":\"" + this.jwt_token + "\"," + "\"bank_id\":\"" + this.userBank_ID + "\"," + "\"section_id\":\"" + this.userWorkSection_ID + "\"," + "\"domainId\":\"" + this.userSelectedDomain_ID + "\"," + "\"sentence\":\"" + strFAQ + "\"}";
            var strResult;
            var URL = "https://www.gototree.com/app/sentence/uploadFaq";
			//Post http通信
			this.$http.post(URL,strData,{emulateJSON:true})
			.then(function(res){
				var strResult = JSON.stringify(res.data)
				if (strResult.indexOf("\"message\":\"操作成功\"") != -1 ){
				   alert("OK，FAQ句子上传成功！");
				}
			},function(res){
			 //显示错误
			 alert(res.status)
			});
		},
		
		//更新资源参数，对第三方资源参数，更新每日最大访问次数
		update_resource_parameter: function(){	
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
		    //判断是否有权限操作
		    if(this.managerAuthority != 1){
				alert("抱歉！无法操作！");
				return
			}
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_parse_url;
			}else{
				use_IP_url = this.local_parse_url;
			}
			//当前时间
			var dateTimeData = new Date();
		    //选择标志
		    var selectMark;
		   //建立调整资源参数标志
			selectMark = "UpdateResourceParameters"
			//备注内容
			this.comment = "0"
			//建立库名,区名,用户名，自动分词标志，显示模板标志，候选模板指针
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + this.auto_word_segment + "/" + this.passWord +  "--" + m_user_host_serial_number + "--" + m_user_host_ip_address + "=" + this.candiate_template_number + "#" + this.sub_template_number + "%" + this.comment + "&" + dateTimeData;  
			//得到更新资源参数的数据
			var update_data = this.parsed_result
			//格式检查
			var normalResult = this.CheckUserResourceDataFormat(update_data)
			var strCheckMark = normalResult.substring(0,normalResult.indexOf("|||"))
			normalResult = normalResult.substring(normalResult.indexOf("|||") + 3,normalResult.length)
			if(strCheckMark != "OK"){//检查有错误？
			   	alert(strCheckMark)
			    return
			}
			//去掉换行的格式符号
			
			normalResult = normalResult.replace(/\r\n/g,"")//去掉换行的格式符号
			normalResult = normalResult.replace(/\r/g,"")//去掉换行的格式符号
			normalResult = normalResult.replace(/\n/g,"")//去掉换行的格式符号
			//显示当前的更新内容
			alert("当前资源参数更新的结果：" + "\r\n" + normalResult)
			
			//得到用户账号
			var ur_phone_number =  normalResult.substring(normalResult.indexOf("UserPhoneNumber=") + "UserPhoneNumber=".length,normalResult.indexOf(",UserHostSerialNumber="))
			
			//得到用户主机编号
			var ur_host_serial_number = normalResult.substring(normalResult.indexOf("UserHostSerialNumber=") + "UserHostSerialNumber=".length,normalResult.indexOf(",AuthorizedTime="))
			//得到用户资源参数
			var ur_resource_parameter = normalResult.substring(normalResult.indexOf("ResourceParameters=[") + "ResourceParameters=[".length,normalResult.lastIndexOf("]"))
			//发送数据 -头部加上用户账号和主机序列号，用于用户身份验证，包括注册和使用期限
			//var sendFinalData = ur_phone_number + "|||" + ur_host_serial_number + "|||" + "[" +ur_resource_parameter +"]"
			var send_data={
			      //发送输入内容
                  id:selectMark,
				  option:option_data,//建立选择库,句子编号,自动分词标志
                  data:normalResult //更新后的数据
            };
			
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){

			//返回响应结果
			var ReceivedData = String(res.data)

			ReceivedData = ReceivedData.substring(ReceivedData.indexOf("Updated result : ")+"Updated result : ".length,ReceivedData.length)
			//显示资源按照换行格式
		    ReceivedData = this.ShowResourceContentWithLineFormat(ReceivedData)
			if(CurrentData == ReceivedData)//返回的数据和发送的设置数据一致？
			{
			   alert("OK,当前的资源参数更新已经完成！")
			}
			else{
			   alert("错误,当前的资源参数更新不正确，发送数据和返回数据不一致！" + "\n" + "发送：" + CurrentData + "\n" + "接受：" + ReceivedData)
			}
			return

			});
        },
		
		//生成用户激活码，并设置软件激活状态为“2”--已付费状态
		create_active_code : function(){
			var strUserMachineNumber = this.faq_question
			var strBizCode = this.faq_answer
			var strValidDays = this.faq_action
			//alert("输入的内容：" + strUserMachineNumber + "--" + strBizCode + "--" + strValidDays)
			//得到激活码
			var strActiveCode = this.generateActivationCode(strBizCode,strValidDays,strUserMachineNumber)
			if (strActiveCode.substring(0,2) != "错误"){//没有错误？
				//清空机器分析区域内容，避免混乱干扰
				this.output_understanding = ""
				//显示激活码
				this.parsed_result = strActiveCode
				//带分隔符显示激活码
                this.parsed_result = strActiveCode.slice(0,4)+ "-" + strActiveCode.slice(4,8)+ "-" + strActiveCode.slice(8,12)

				alert("OK,激活码已生成完毕！" + "   " + strActiveCode + "   " + "--" + strUserMachineNumber + "--" + strBizCode + "--" + strValidDays)
                //发送激活状态数据
				var strActiveCodeStatus = "2" //设置为“2” --已付费状态
		        this.send_active_code_status(strUserMachineNumber,strActiveCodeStatus,strBizCode,strValidDays) 		   
		   }
			else{
			   //显示出错误的信息内容
			   alert(strActiveCode)
			}
		},
		
		//检查用户资源数据格式
		CheckUserResourceDataFormat: function(update_data){
            //格式检查[//这里只是简单检查一下，细节检查有数值是否正确，命名是否正确等 ==》 这里暂时使用，以后可以考虑表格只允许改数据部分，就更可靠]
			var oneLine = ""
			var normalResult = ""
			var strCheckMark = "OK";
			var i = 0;
			while(update_data.indexOf("\r\n") != -1){//有换行符？
			   oneLine = update_data.substring(0,update_data.indexOf("\r\n"))
			   update_data = update_data.substring(update_data.indexOf("\r\n") + 2,update_data.length)
			   if(i == 0){//是第一行？
			      if(oneLine.indexOf("BankName=") != 0){//是标准格式开头？
				     strCheckMark = "错误，第一行不是以”BankName=“标识开头"
				     break
				  }
			   }
			   else if(i == 1){//是第二行？
			      if(oneLine  != "ResourceParameters=["){//是标准资源标识符开头？
				     strCheckMark = "错误，第二行不是以”ResourceParameters=[“标识开头"
				     break
				  }
			   }
			   else 
			   {
			      if(oneLine.indexOf(":{") == -1 || oneLine.indexOf("},") == -1 ){//有标准的开始和结束符？		     
				     strCheckMark = "错误，第" + String(i + 1) + "行不是以标准的“:{”开始或者结束符“},”格式。"
				     break
				  }
			   }
			   //去掉空格
			   oneLine = oneLine.replace(" ","")
			   normalResult += oneLine
			   i++

			}

			//最后一行
			oneLine = update_data
		    if(oneLine.indexOf(":{") == -1 || oneLine.indexOf("}]") == -1 ){//最后一行有标准的开始和结束符？		     
			   strCheckMark = "错误，最后一行不是以标准的“:{”开始或者结束符“}]”格式。"			   
		    }	
		    //去掉空格
		    oneLine = oneLine.replace(" ","")
		    normalResult += oneLine
			if(strCheckMark != "OK"){//不是OK 格式？
			   alert(strCheckMark)
			   normalResult = "Error|||" + normalResult
			}
			else{
			   normalResult = "OK|||" + normalResult			
			}
			return normalResult
		},
		//更新资源 --- 第三方资源访问码
		update_resource_access_code: function(){	
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
		    //判断是否有权限操作
		    if(this.managerAuthority != 1){
				alert("抱歉！无法操作！");
				return
			}
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_parse_url;
			}else{
				use_IP_url = this.local_parse_url;
			}
			//当前时间
			var dateTimeData = new Date();
		    //选择标志
		    var selectMark;
		   //建立选择标志
			selectMark = "UpdateResourceAccessCode"
			//备注内容
			this.comment = "0"
			//建立库名,区名,用户名，自动分词标志，显示模板标志，候选模板指针
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + this.auto_word_segment + "/" + this.passWord +  "--" + m_user_host_serial_number + "--" + m_user_host_ip_address + "=" + this.candiate_template_number + "#" + this.sub_template_number + "%" + this.comment + "&" + dateTimeData;  
			//输入内容 格式【第三方资源名称（如华为云\图像标签识别）|||资源用户编号|||资源ID|||资源Key】
			//资源名称
			var resource_name = this.input_sentence
			if(resource_name.indexOf("--") == -1){//不含有--子名称符号？
				alert("错误，格式错误，资源名称必须”主资源名称--子资源名称“格式！");
				return			
			}
		    //资源访问码编号
			var resource_number_in_resource = this.resource_number_in_document
			if(isNaN(Number(resource_number_in_resource))){//不是有效数字？
				alert("错误，格式错误，资源用编号必须是数字值！");
				return			
			}
			//资源Appkey
			var resource_appkey = this.faq_question.trim()
			if(resource_appkey.indexOf(" ") != -1){//不含有空格？
				alert("错误，格式错误，资源中Appkey不能为空！");
				return			
			}
			if(resource_appkey == ""){//为空？
				alert("错误，格式错误，资源Appkey中不能含有空格！");
				return			
			}
			//资源Id
			var resource_id = this.faq_answer.trim()
			if(resource_id.indexOf(" ") != -1){//不含有空格？
				alert("错误，格式错误，资源中id不能为空！");
				return			
			}
			if(resource_id == ""){//为空？
				alert("错误，格式错误，资源id中不能含有空格！");
				return			
			}
			//资源Key
			var resource_key = this.faq_action.trim() 
			if(resource_key.indexOf(" ") != -1){//不含有空格？
				alert("错误，格式错误，资源中key不能含有空格！");
				return			
			}
			if(resource_key == ""){//为空？
				alert("错误，格式错误，资源中key不能为空！");
				return			
			}

			//得到整个传输数据内容
			var input_content = resource_name + "|||" + resource_number_in_resource + "|||" + resource_appkey + "|||" + resource_id + "|||" + resource_key;
			alert(input_content)
			//加密处理
			input_content = this.encryptString(input_content)
			//显示加密结果
			this.faq_meaning = input_content
			//提示
			alert(input_content)
			//加上资源编号,提供商名称 ---便于云服务器端快速处理（不必重新解析加密数据）
			input_content =  resource_number_in_resource +  "|||" + resource_name + "|||" + input_content
			var send_data={
			  //发送输入内容
			  id:selectMark,
			  option:option_data,//建立选择库,句子编号,自动分词标志
			  data:input_content //输入内容
            };
			
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){

			//返回响应结果
			alert(res.data)
			//显示处理结果信息
			this.parsed_result = res.data
			return

			});
        },

		//解析资源 --- 查看第三方资源访问码
		watch_resource_access_code: function(){	
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
		    //判断是否有权限操作
		    if(this.managerAuthority != 1){
				alert("抱歉！无法操作！");
				return
			}			//当前时间
			var dateTimeData = new Date();
			//资源名称
			var resource_name = ""
		    //资源用户编号
			var resource_number = ""
			//资源Appkey
			var resource_appkey = ""
			//资源Id
			var resource_id = ""
			//资源Key
			var resource_key = "" 
			
			//得到加密内容
			var encryptedContent = this.output_understanding
			//输入内容 格式【第三方资源名称（如华为云）|||资源用户编号|||资源ID|||资源Key】
			
			var bolProcessingResult = true //初始化状态值
			var resultContent = this.decryptString(encryptedContent)
			if(resultContent.indexOf("|||") != -1){
			  //资源名称
			   resource_name = resultContent.substring(0,resultContent.indexOf("|||"))
			   resultContent = resultContent.substring(resultContent.indexOf("|||") + 3,resultContent.length)
			}
			else{
			   bolProcessingResult = false //建立处理失败状态值
			}
			if(resultContent.indexOf("|||") != -1){
				//资源用户编号
				resource_number = resultContent.substring(0,resultContent.indexOf("|||"))
			    resultContent = resultContent.substring(resultContent.indexOf("|||") + 3,resultContent.length)
			}
			else{
			   bolProcessingResult = false //建立处理失败状态值
			}			
			if(resultContent.indexOf("|||") != -1){
				//资源Appkey
			   resource_appkey = resultContent.substring(0,resultContent.indexOf("|||"))
			   resultContent = resultContent.substring(resultContent.indexOf("|||") + 3,resultContent.length)
			}
			else{
			   bolProcessingResult = false //建立处理失败状态值
			}
			if(resultContent.indexOf("|||") != -1){
				//资源Id
			   resource_id = resultContent.substring(0,resultContent.indexOf("|||"))
			   resultContent = resultContent.substring(resultContent.indexOf("|||") + 3,resultContent.length)
			}
			else{
			   bolProcessingResult = false //建立处理失败状态值
			}			
			//资源Key
			resource_key = resultContent 		


			//返回响应结果
			if(bolProcessingResult != false){//正确处理完成？
				//显示资源名称
				this.input_sentence = resource_name
				//显示资源用户编号
				this.resource_number_in_document = resource_number
				//显示资源Appkey
				this.faq_question = resource_appkey
				//显示资源Id
				this.faq_answer = resource_id
				//显示资源Key
				this.faq_action = resource_key 
				//显示处理过程信息
				this.parsed_result = "OK,JX资源处理完成！---- " + dateTimeData
			}
			else{
				//显示处理过程信息
				this.parsed_result = "抱歉,JX资源处理异常！数据格式不正确“ ---- " + dateTimeData
			}
			alert(this.parsed_result)
			return

        },
		
		//增加资源 --- 增加第三方资源访问码
		add_resource_access_code: function(){	
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
		    //判断是否有权限操作
		    if(this.managerAuthority != 1){
				alert("抱歉！无法操作！");
				return
			}
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_parse_url;
			}else{
				use_IP_url = this.local_parse_url;
			}
			//当前时间
			var dateTimeData = new Date();
		    //选择标志
		    var selectMark;
		   //建立选择标志
			selectMark = "AddResourceAccessCode"
			//备注内容
			this.comment = "0"
			//建立库名,区名,用户名，自动分词标志，显示模板标志，候选模板指针
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + this.auto_word_segment + "/" + this.passWord +  "--" + m_user_host_serial_number + "--" + m_user_host_ip_address + "=" + this.candiate_template_number + "#" + this.sub_template_number + "%" + this.comment + "&" + dateTimeData;  
			//输入内容 格式【第三方资源名称（如华为云\图像标签识别）|||资源用户编号|||资源ID|||资源Key】
			//资源名称
			var resource_name = this.input_sentence
			if(resource_name.indexOf("--") == -1){//不含有--子名称符号？
				alert("错误，格式错误，资源名称必须”主资源名称--子资源名称“格式！");
				return			
			}
		    //资源访问码编号 !!!增加资源时,资源编号从文件中自动推算新加资源编号 !!!!!
			var resource_number_in_resource = String(Number(this.GetTotalOfResourceCode()) +1)
			if(isNaN(Number(resource_number_in_resource))){//不是有效数字？
				alert("错误，格式错误，资源用编号必须是数字值！");
				return			
			}
			//资源Appkey
			var resource_appkey = this.faq_question.trim()
			if(resource_appkey.indexOf(" ") != -1){//不含有空格？
				alert("错误，格式错误，资源中Appkey不能为空！");
				return			
			}
			if(resource_appkey == ""){//为空？
				alert("错误，格式错误，资源Appkey中不能含有空格！");
				return			
			}
			//资源Id
			var resource_id = this.faq_answer.trim()
			if(resource_id.indexOf(" ") != -1){//不含有空格？
				alert("错误，格式错误，资源中id不能为空！");
				return			
			}
			if(resource_id == ""){//为空？
				alert("错误，格式错误，资源id中不能含有空格！");
				return			
			}
			//资源Key
			var resource_key = this.faq_action.trim() 
			if(resource_key.indexOf(" ") != -1){//不含有空格？
				alert("错误，格式错误，资源中key不能含有空格！");
				return			
			}
			if(resource_key == ""){//为空？
				alert("错误，格式错误，资源中key不能为空！");
				return			
			}
			//得到整个传输数据内容
			var input_content = resource_name + "|||" + resource_number_in_resource + "|||" + resource_appkey + "|||" + resource_id + "|||" + resource_key;
			//加密处理
			input_content = this.encryptString(input_content)
			//显示加密结果
			this.faq_meaning = input_content
			//提示
			alert("新增资源内容：" + input_content)
			//加上资源编号,提供商名称 ---便于云服务器端快速处理（不必重新解析加密数据）
			input_content =  resource_number_in_resource +  "|||" + resource_name + "|||" + input_content
			var send_data={
			  //发送输入内容
			  id:selectMark,
			  option:option_data,//建立选择库,句子编号,自动分词标志
			  data:input_content //输入内容
            };
			
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){

			//返回响应结果
			alert(res.data)
			//显示处理结果信息
			this.parsed_result = res.data
			//更新资源码编号
			resource_number_in_resource = res.data.substring(res.data.indexOf("resource code number:") + "resource code number:".length,res.data.length)
			this.resource_number_in_document = resource_number_in_resource + "/" + resource_number_in_resource
			return

			});
        },
		// 加密字符串
		encryptString: function(str) {
		  var intValue = 90
		  var array = new Uint8Array(str.length);
		  for (var i = 0; i < str.length; i++) {
			array[i] = str.charCodeAt(i);
			//加密数组值  --在0-4变化值--取5余数
			array[i] = array[i] + intValue + (i % 5) 
		  }
		  var resultString = String.fromCharCode.apply(null, array);
		  return resultString;
		},
		//解密字符串
		decryptString: function(str){
		  var resultString
		  var intValue = 90
		  var array = new Uint8Array(str.length);
		  for (var i = 0; i < str.length; i++) {
			array[i] = str.charCodeAt(i);
			//加密数组值
			//加密数组值  --在0-4变化值--取5余数
			array[i] = array[i] - intValue - (i % 5)
		  }
		  resultString = String.fromCharCode.apply(null, array);
		  return resultString;
		},
 		//对输入句进行句法分析
		parse_sentence: function(){	
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_parse_url;
			}else{
				use_IP_url = this.local_parse_url;
			}
			//当前时间
			var dateTimeData = new Date();
		    //选择句库标志
		    var selectMark;
			var strParsedResult;
			var strUnderstoodResult;
		   //建立选择句库句分析标志
			selectMark = "Parse"
			//选择指定的句库
			//备注内容
			this.comment = "0"
			//建立库名,区名,用户名，自动分词标志，显示模板标志，候选模板指针
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + this.auto_word_segment + "/" + this.passWord +  "--" + m_user_host_serial_number + "--" + m_user_host_ip_address + "=" + this.candiate_template_number + "#" + this.sub_template_number + "%" + this.comment + "&" + dateTimeData;  
			//句子内容
		    var test_sentence = this.input_sentence;
			var send_data={
			      //发送测试句子
                  id:selectMark,
				  option:option_data,//建立选择库,句子编号,自动分词标志
                  data:test_sentence //句子内容
            };
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){

			//句法树数据
			if (res.data == "")//为空?
			{
			   //读取开机显示原始树
			    this.ShowInintializationParsedTree();
				alert("抱歉，当前分析失败，需要对当前的句子进行学习！")
				//清空结果文件
				this.parsed_result = ""
			    return
			}
		    //得到对句法树子信息解析的句法树
		//    this.get_tree_with_subinformation(res.data)
			//转换JSON格式句法树到括号型的句法树
		// 	strParsedResult = this.TranJSONSyntaxTreeToNormalFormat(JSON.stringify(res.data))
		  var lineData = res.data
		  //得到数据头
		  var strDataHead = lineData.substring(0,lineData.indexOf("|||"))
		  //剩余数据
		  lineData  = lineData.substring(lineData.indexOf("|||") + 3,lineData.length)
		  //得到库名
		  var bank_name = strDataHead.substring(strDataHead.indexOf("bank:") + "bank:".length,strDataHead.indexOf(" section:"))
		  //得到区名
		  var section_name = strDataHead.substring(strDataHead.indexOf(" section:") + " section:".length,strDataHead.indexOf(" number:"))

		  //得到编号
		  var object_number = strDataHead.substring(strDataHead.indexOf(" number:") + " number:".length,strDataHead.indexOf(" score:"))
		  var currentPointer = object_number.substring(0,object_number.indexOf("/"))
		  var TotalCount = object_number.substring(object_number.indexOf("/")+1,object_number.length)
		  //显示库名
//		  this.bank_name = bank_name
		  //显示区名
//		  this.section_name = section_name
		  //显示编号数据
		  this.sentence_number_of_template = object_number

			//提取匹配得分，模板ID，句法树 ////////2022.5.24修改，不用JSON,同时加了得分和模板ID输出功能
			var score = strDataHead.substring(strDataHead.indexOf(" score:") + " score:".length,strDataHead.indexOf(" template:"))
			this.match_score = score
		    strDataHead = strDataHead.substring(strDataHead.indexOf(" ") + 1,strDataHead.length)	
			var template_ID = strDataHead.substring(strDataHead.indexOf(" template:") + " template:".length,strDataHead.indexOf(" ip:"))
			this.matched_template_id = template_ID
			
            strParsedResult = lineData.substring(0,lineData.indexOf(">>>"))
			//在输出结果位置显示句法树（括号型）
			this.parsed_result = strParsedResult;
			if (strParsedResult == ""){ //是空结果?
				//读取开机显示原始树
		        this.ShowInintializationParsedTree();
				//清空得分数据
				this.match_score = "0.00"
		        this.match_score_style.background = "#CC8"
		        this.matched_template_id = "00000"
		        this.matched_template_id_style.background ="#8CA"
				
			    alert("抱歉，当前分析失败，需要对当前的句子进行学习！")	
				
                return				
            }
			//得到理解的结果
			strUnderstoodResult = lineData.substring(lineData.indexOf(">>>") + ">>>".length,lineData.length)
			///输出机器理解的结果
			if (this.check_simply_show == true){//是简化显示?
			   strUnderstoodResult = this.SimplyShowUnderstoodResult(strUnderstoodResult)
			}
			this.output_understanding = strUnderstoodResult
		    //显示分析结果
		    this.display_result()	

			//跳转当前序号第一个的Rank模板
			this.template_number_on_rank = "1"
			if (this.check_show_template == true) {//是显示模板模式?
			   this.jump_now_rank_template();	
			}else{
			   this.match_score = score //显示得分
			}
			console.log(strParsedResult)
			},function(res){
			 //错误
			 //读取开机显示原始树
		     this.ShowInintializationParsedTree();
			 //清空得分数据
			 this.match_score = "0.00"
			 this.match_score_style.background = "#CC8"
			 this.matched_template_id = "00000"
			 this.matched_template_id_style.background ="#8CA"
			
			 alert("抱歉，当前分析失败，需要对当前的句子进行学习！")	
			});
        },
       //显示模板库中模板信息
        ShowAllInformationForTemplateInBank: function(lineData){			  
		  //在文件中的行序号
		  var LineNumberInFile = lineData.substring(0,lineData.indexOf("  "))
		  lineData = lineData.substring(lineData.indexOf("  ")+ 2,lineData.length)	
		  //模板的区内句子编号：
		  var SentenceNumberInSection = lineData.substring(0,lineData.indexOf(" "))
		  lineData = lineData.substring(lineData.indexOf(" ")+ 1,lineData.length)	
		  //句子ID：
		  var SentenceID = lineData.substring(0,lineData.indexOf(" "))
		  lineData = lineData.substring(lineData.indexOf(" ")+ 1,lineData.length)	
		  //模板ID：
		  var TemplateID = lineData.substring(0,lineData.indexOf(" "))
		  lineData = lineData.substring(lineData.indexOf(" ")+ 1,lineData.length)	
		  //编辑限定：
		  var EditCommand = lineData.substring(0,lineData.indexOf(" "))
		  lineData = lineData.substring(lineData.indexOf(" ")+ 1,lineData.length)	
		  //规则限定：
		  var RuleResult = lineData.substring(0,lineData.indexOf(" "))
		  lineData = lineData.substring(lineData.indexOf(" ")+ 1,lineData.length)	
		  //用户ID：
		  var UserID = lineData.substring(0,lineData.indexOf(" "))
		  lineData = lineData.substring(lineData.indexOf(" ")+ 1,lineData.length)	
		  //完成时间：
		  var FinishTime = lineData.substring(0,lineData.indexOf(" "))
		  lineData = lineData.substring(lineData.indexOf(" ")+ 1,lineData.length)	
		  //备注：
		  var Comment = lineData.substring(0,lineData.indexOf(" "))
		  lineData = lineData.substring(lineData.indexOf(" ")+ 1,lineData.length)	
		  //匹配得分：
		  var MatchScore = lineData.substring(0,lineData.indexOf(" "))
		  lineData = lineData.substring(lineData.indexOf(" ")+ 1,lineData.length)	
		  //模板单元数量：
		  var UnitCount = lineData.substring(0,lineData.indexOf("  "))
		  lineData = lineData.substring(lineData.indexOf("  ")+ 2,lineData.length)	
		  //更新编辑限定值
		  if (EditCommand == "增加")
		  {
			 this.edited_result_style.background="#0F0"
			 this.edited_result = EditCommand
		  }
		  if (EditCommand == "修改")
		  {
			 this.edited_result_style.background="#0CF"
			 this.edited_result = EditCommand
		  }
		  if (EditCommand == "删除")
		  {
			 this.edited_result_style.background="#F00"
			 this.edited_result = EditCommand
		  }
		  //更新规则限定值
		  if (RuleResult == "允许")
		  {
			 this.ruled_result_style.background="#0F0"
			 this.ruled_result = RuleResult

		  }
		  if (RuleResult == "禁止")
		  {
			 this.ruled_result_style.background="#F00"
			 this.ruled_result = RuleResult
		  }
		  //显示匹配得分
		  this.match_score = MatchScore
		  //对不同的得分显示不同的颜色
		  if (Number(MatchScore) < 0.6)
		  {
		  	this.match_score_style.background="#F00"
		  }
		  if (Number(MatchScore) >= 0.7)
		  {
		  	this.match_score_style.background="#FC6"
		  }
		  if (Number(MatchScore) >= 0.8)
		  {
		  	this.match_score_style.background="#0CF"
		  }
		  if (Number(MatchScore) >= 0.9)
		  {
		  	this.match_score_style.background="#0F0"
		  }
         //得到句法树中句子内容
		  var sentence_content = lineData
		  sentence_content = sentence_content.substring(sentence_content.indexOf(">>")+ 2,sentence_content.length)
		  sentence_content = sentence_content.substring(0,sentence_content.indexOf(" "))
		  //增加模板属性信息
		  var template_attribute = LineNumberInFile + "  " + SentenceNumberInSection + " "  + SentenceID + " " + TemplateID + " " + EditCommand  + " " + RuleResult + " " + UserID + " " + FinishTime + " " + Comment + " " + MatchScore + " " + UnitCount
		  //显示模板句子
		  while(sentence_content.indexOf("+") != -1)
		  {
		     sentence_content = sentence_content.replace('+',' ')
		  }
		  this.input_sentence = sentence_content  + " === " + template_attribute
		  //得到句法树
		  var ParsedTree = lineData
		  //在输出结果位置显示句法树（括号型）
		  this.parsed_result = ParsedTree;
		  ///输出机器理解的结果
		  this.output_understanding = "!!!!"
		  //显示分析结果
		  this.display_result()
		},
		//显示分析结果
		display_result: function(){	
			//句法树数据（括号型）
			var strSyntaxTree;
			//句法树数据（JSON型）
			var strJSONSyntaxTree;
			//得到对句法树子信息解析的句法树
			strSyntaxTree = this.parsed_result;
			//转换括号型句法树到JSON格式的句法树
			strJSONSyntaxTree = this.TranNormalSyntaxTreeToJSONFormat(strSyntaxTree);
		//	strJSONSyntaxTree = "{"node_content":"那时+我+在+上海+。","node_attribute":"C4:=.AD+PN+P+NR+PU/Fa070104+Ab010101+Na010102+Za030102+Ww040101~!0<<>>","children":[ {"node_content":"那时+我+在+上海","node_attribute":"C3:=.AD+PN+P+NR/Fa070104+Ab010101+Na010102+Za030102~!1<<>>","children":[ {"node_content":"那时","node_attribute":"W1:.AD-Fa070104~!0<<>>"},{"node_content":"我+在+上海","node_attribute":"C2:=.PN+P+NR/Ab010101+Na010102+Za030102~!1<<>>","children":[ {"node_content":"我","node_attribute":"W2:.PN/Ab010101~!1<<>>"},{"node_content":"在+上海","node_attribute":"C1:=.P+NR/Na010102+Za030102~!1<<>>","children":[ {"node_content":"在","node_attribute":"W3:.P/Na010102~!1<<1:Time;2:Exp;4:Loc;5:mPunc>>"},{"node_content":"上海","node_attribute":"W4:.NR/Za030102~!1<<>>"}]} ]} ]},{"node_content":"。","node_attribute":"W5:.PU/Ww040101~!0<<>>"}]}"
			myTreeObj = JSON.parse(strJSONSyntaxTree)
			//建立JSON对象
		    var myTreeObj;
			////////建立和显示树节点数据/////////
            //增加节点的子信息属性项--初始值为空值
			//myTreeObj = strJSONSyntaxTree.replace(/"node_content"/g, '"role":"","state":"","link":"","head":"","entity":"","sense":"","pos":"","word":"","number":"","node_content"')
			//myTreeObj = eval('('+ myTreeObj + ')');
			myTreeObj = JSON.parse(strJSONSyntaxTree)
			//建立节点属性的子信息
			this.set_node_subinformation(myTreeObj);
			this.data= myTreeObj;
        },
		/////递归查询JSON树,建立中心词节点标志//////////////
 		setHeadWordNodeMark(myTreeObj,parentNode) {
			//1.第一层 root 深度遍历整个JSON
			for(var i in myTreeObj) {
				//2.有节点就开始找，一直递归下去
				if (i === "node_attribute") {
				    //节点索引号计数
				    this.rootNodeCount++
					//关闭基点显示状态
					myTreeObj["state"] = String(Number(myTreeObj["state"]) % 100)
					//如果有标志，清除基点焦点节点标志
					if(myTreeObj["word"].substring(0,1) == '●'){
					    //清除基点标志
						myTreeObj["word"] = myTreeObj["word"].substring(1,myTreeObj["word"].length)
					}
					//判断是否点击的节点,如果是，建立焦点显示标志
					if(this.node_number === myTreeObj["number"])
					{
						//设置初始化点击焦点标志
						myTreeObj["state"] = String(Number(myTreeObj["state"]) + 10000)
					}
					else{ //先恢复个位的标注状态值
						myTreeObj["state"] = String(Number(myTreeObj["state"]) % 100);
						//建立标志
						myTreeObj["state"] = String(Math.floor(Number(myTreeObj["state"]) / 10) * 10 + 3)
					}
				}
				//3.如果有子节点，就从子节点开始找
				else if (i === "children") {
					//4.递归前，记录当前节点作为parent 父节点
					var sub_parentNode = myTreeObj
					//从数组中取对象
					for(var j in myTreeObj[i]) {
					   //递归往下找
					   if (j != null ){
						  this.setHeadWordNodeMark(myTreeObj[i][j],sub_parentNode);
					   }
					}
				}
			}
		},
		/////递归查询JSON树,找到指定的索引节点，并建立为焦点节点标志//////////////
 		setFocusNodeMark(myTreeObj,parentNode) {
			//1.第一层 root 深度遍历整个JSON
			for(var i in myTreeObj) {
				//2.有节点就开始找，一直递归下去
				if (i === "node_attribute") {
				    //节点索引号计数
				    this.rootNodeCount++
					//关闭基点显示状态
					myTreeObj["state"] = String(Number(myTreeObj["state"]) % 100)
					//如果有标志，清除基点焦点节点标志
					if(myTreeObj["word"].substring(0,1) == '●'){
					    //清除基点标志
						myTreeObj["word"] = myTreeObj["word"].substring(1,myTreeObj["word"].length)
					}
					//设置初始化基点的标注状态和卫星节点的标注状态
					myTreeObj["state"] = this.SetInitialBaseNodeAndPlanetNodeState()
                    //判断是否指定内容===》（注意！！！节点位置编号必须是全局性的唯一标识，否则会出错！唯一标识，否则会出错！）
				    if (Number(this.label_BaseNode_Position) === this.rootNodeCount){ //是指定节点索引的位置？
		     		    //基点焦点节点标志
						myTreeObj["word"] = "●" + myTreeObj["word"]						
						//建立焦点显示标志
					    //开启基点显示状态
					    myTreeObj["state"] = String(Number(myTreeObj["state"]) + 10000)
						//不退出，为了清除可能在随后的旧标志
 						//break;
					}
					else{
						//先恢复个位的标注状态值
						myTreeObj["state"] = String(Number(myTreeObj["state"]) % 100);
						//按有效关联的节点数组数据设置相关节点的显示状态
						if (this.CheckAvailableRelativeNode(myTreeObj["number"]) === true) {
							//建立个位的卫星节点状态 == 建立标注过标志
							myTreeObj["state"] = String(Math.floor(Number(myTreeObj["state"]) / 10) * 10 + 3)
						}
						else{
							//建立个位的卫星节点状态 == 建立未标注标志
							myTreeObj["state"] = String(Math.floor(Number(myTreeObj["state"]) / 10) * 10 + 2)
						}
					}
				} 
				//3.如果有子节点，就从子节点开始找
				else if (i === "children") {
					//4.递归前，记录当前节点作为parent 父节点
					var sub_parentNode = myTreeObj
					//从数组中取对象
					for(var j in myTreeObj[i]) {
					   //递归往下找
					   if (j != null ){
						  this.setFocusNodeMark(myTreeObj[i][j],sub_parentNode);
					   }
					}
				}
			}
		},
		///简化显示机器理解的结果
		SimplyShowUnderstoodResult(strUnderstoodResult){
		    var strSimplyUnderstoodResult = ""
			var strOneUnit = ""
			var line_pos = 0
			var pos = 0
			var strLineUnderstoodResult = ""
			var strLineSimplyUnderstoodResult = ""
			while (strUnderstoodResult != ""){
			    line_pos = strUnderstoodResult.indexOf("\r\n")
				if (line_pos != -1){
				   strLineUnderstoodResult = strUnderstoodResult.substring(0,line_pos)
				   strUnderstoodResult = strUnderstoodResult.substring(line_pos + 2,strUnderstoodResult.length)
				}
				else{
				   strLineUnderstoodResult = strUnderstoodResult
				   strUnderstoodResult = ""
				}
				strLineSimplyUnderstoodResult = ""
				while (strLineUnderstoodResult != ""){
					pos = strLineUnderstoodResult.indexOf(" ")
					if (pos != -1) {
					   strOneUnit = strLineUnderstoodResult.substring(0,pos)
					   strLineUnderstoodResult = strLineUnderstoodResult.substring(pos+1,strLineUnderstoodResult.length)
					}
					else{
					   strOneUnit = strLineUnderstoodResult
					   strLineUnderstoodResult = ""
					}
					//去掉编号，去掉描述内容
					strOneUnit = strOneUnit.substring(strOneUnit.indexOf(":")+1,strOneUnit.indexOf("-"))
					if (strLineSimplyUnderstoodResult == ""){
					   strLineSimplyUnderstoodResult = strOneUnit
					}
					else{
					   strLineSimplyUnderstoodResult += " " + strOneUnit
					}
				}
				//加上换行符号
				if (strSimplyUnderstoodResult == "") {
				   strSimplyUnderstoodResult = strLineSimplyUnderstoodResult
				}
				else{
				   strSimplyUnderstoodResult += "\r\n" + strLineSimplyUnderstoodResult
				}
			}
			return strSimplyUnderstoodResult
		},
		/////设置初始化的基点的标注状态和卫星节点的标注状态
		SetInitialBaseNodeAndPlanetNodeState() {
		   //基点未标注，卫星节点未标注
		   var m_state_0 = '23'
		   return m_state_0
		},
		/////递归查询JSON树,建立所有节点参数//////////////
		setAllNodeMark(myTreeObj) { 
			//1.第一层 root 深度遍历整个JSON
			for(var i in myTreeObj) {

				//2.有节点就开始找，一直递归下去
				if (i === "number") {
					//节点索引号计数
					this.rootNodeCount++
					 //是查看显示模式
					if (Number(myTreeObj["state"]) >= 10000) {//是焦点状态？
						//记录这个焦点节点的对象
						this.node_buffer = myTreeObj
					}
					else{
						//先恢复个位的标注状态值
						myTreeObj["state"] = String(Number(myTreeObj["state"]) % 1000);
						//按有效关联的节点数组数据设置相关节点的显示状态
						if (this.CheckAvailableRelativeNode(myTreeObj["number"]) === true) {
							//再设置查看状态  ====关联节点颜色
							myTreeObj["state"] = String(Number(myTreeObj["state"]) + 2000);
							//得到与基点相关的角色信息
							myTreeObj["role"] = this.GetTheRoleLinkToBasePoint(myTreeObj["node_attribute"]);
						}
						else{
							//设置查看状态  ====非关联节点颜色
							myTreeObj["state"] = String(Number(myTreeObj["state"]) + 1000);
						}
					}
					//不退出，为了随后的全操作
					//break;
				//3.如果有子节点，就从子节点开始找
				}else if (i === "children") {
					//4.递归前，记录当前节点作为parent 父节点
					var sub_parentNode = myTreeObj
					//从数组中取对象
					for(var j in myTreeObj[i]) {
					   //递归往下找
					   if (j != null ){
						  this.setAllNodeMark(myTreeObj[i][j]);
					   }
					}
				}
			}
		},
		/////递归查询JSON树,通过索引找到指定节点//////////////
		findSpecifiedNodeByNodeIndex(myTreeObj) { 
			//1.第一层 root 深度遍历整个JSON
			for(var i in myTreeObj) {
				//2.有节点就开始找，一直递归下去
				if (i === "node_attribute") {
					this.rootNodeCount++
					//是相同的索引位置?
					if (this.rootNodeCount === Number(this.SpecifiedNodeIndex)) {
					    //建立查找到的节点
						this.foundNode = myTreeObj
						//退出
					    break;
					}
				}
 				//3.如果有子节点，就从子节点开始找
				else if (i === "children") {
					//4.递归前，记录当前节点作为parent 父节点
					var sub_parentNode = myTreeObj
					//从数组中取对象
					for(var j in myTreeObj[i]) {
					   //递归往下找
					   if (j != null ){
						  this.findSpecifiedNodeByNodeIndex(myTreeObj[i][j]);
					   }
					}
				}
			}
		},		
		/////递归查询JSON树,通过节点编号找到指定节点//////////////
		findSpecifiedNodeIndexByNodeNumber(myTreeObj) { 
			//1.第一层 root 深度遍历整个JSON
			for(var i in myTreeObj) {
				//2.有节点就开始找，一直递归下去
				if (i === "number") {
					this.rootNodeCount++
					//是相同的节点编号位置?
					if (myTreeObj[i] === this.node_number) {
					    //建立查找到的节点索引
						this.foundNode = myTreeObj
						//退出
					    break;
					}
				}
 				//3.如果有子节点，就从子节点开始找
				else if (i === "children") {
					//4.递归前，记录当前节点作为parent 父节点
					var sub_parentNode = myTreeObj
					//从数组中取对象
					for(var j in myTreeObj[i]) {
					   //递归往下找
					   if (j != null ){
						  this.findSpecifiedNodeIndexByNodeNumber(myTreeObj[i][j]);
					   }
					}
				}
			}
		},		
		/////递归查询JSON树,清除节点的显示标志//////////////
		clearAllNodeShowMark(myTreeObj) { 
			//1.第一层 root 深度遍历整个JSON
			for(var i in myTreeObj) {

				//2.有节点就开始找，一直递归下去
				if (i === "number") {
					//节点索引号计数
					this.rootNodeCount++
					//清除节点的显示标志 == for焦点
					myTreeObj["state"] = String(Number(myTreeObj["state"]) % 10000);
					//是相同的索引位置?
					//不退出
					//break
				}
 				//3.如果有子节点，就从子节点开始找
				else if (i === "children") {
					//4.递归前，记录当前节点作为parent 父节点
					var sub_parentNode = myTreeObj
					//从数组中取对象
					for(var j in myTreeObj[i]) {
					   //递归往下找
					   if (j != null ){
						  this.clearAllNodeShowMark(myTreeObj[i][j]);
					   }
					}
				}
			}
		},
		//按有效关联的节点数组数据设置相关节点的显示状态
		CheckAvailableRelativeNode(NodeNumber) {
			var i = 1
			var bolMark = false
			//得到有效关联节点数量
			var intRelNodeCount = Number(this.relativeNodeArray[0])
			while (i <= intRelNodeCount) {
			   //是相同的节点索引?
			   if (NodeNumber === this.relativeNodeArray[i]) {
			       //建立相同索引标志
			       bolMark = true
				   break
			   }
			   i++
			}
			return bolMark
		},
		//得到与基点相关的角色信息
		GetTheRoleLinkToBasePoint(m_attribute) {
		    var roleData = ""
			var intGapPostion = 0
			var tempAttributeName = ''
			var tempOneAttributeData = ''
			var AttributeNameindex = ''
			var directionData = ''
			var relativeNode = ''
			var m_direction = ''
 		    //去掉封装标识
			if (m_attribute.indexOf("<<") != -1) {
			    m_attribute = m_attribute.substring(m_attribute.indexOf("<<")+2,m_attribute.length)
			}
			if (m_attribute.indexOf(">>") != -1) {
			    m_attribute = m_attribute.substring(0,m_attribute.indexOf(">>"))
			}
			while(m_attribute != "") {
			    //得到一个属性数据的结尾位置
			    intGapPostion = m_attribute.indexOf(",")
			    if (intGapPostion != -1) {
				   //得到一个属性数据
				   tempOneAttributeData = m_attribute.substring(0,intGapPostion)
				   //剩余的属性数据序列
				   m_attribute = m_attribute.substring(intGapPostion+1,m_attribute.length)
			    }
			    else {
			       tempOneAttributeData = m_attribute
				   m_attribute = ""
			    }
			    //得到属性名
			    intGapPostion = tempOneAttributeData.indexOf(":")
			    tempAttributeName = tempOneAttributeData.substring(0,intGapPostion)
			    //剩余部分
			    tempOneAttributeData = tempOneAttributeData.substring(intGapPostion+1,tempOneAttributeData.length)
			    //得到属性名索引
			    intGapPostion = tempAttributeName.indexOf(".")
			    AttributeNameindex = tempAttributeName.substring(0,intGapPostion)
			    //得到方向数据
			    intGapPostion = tempOneAttributeData.indexOf("-")
			    directionData = tempOneAttributeData.substring(0,intGapPostion)
			    tempOneAttributeData = tempOneAttributeData.substring(intGapPostion+1,tempOneAttributeData.length)
			    //得到关联基点编号
			    relativeNode = tempOneAttributeData
				if( relativeNode === this.node_number) {//是与当前的标注基点相同吗?
                   //建立显示的角色信息
					if(directionData === "01"){
					    m_direction = ">"
					}
					if(directionData === "10"){
					    m_direction = "<"
					}
					if(directionData === "11"){
					    m_direction = "<>"
					}
					if (roleData === "") {
					   roleData =  m_direction + tempAttributeName;
					}
					else{
					  roleData += ";" + m_direction + tempAttributeName;
					}
			    }
			}
			return roleData
		},
		//转换括号型句法树到JSON格式的句法树
		TranNormalSyntaxTreeToJSONFormat(strSyntaxTree) {
			var intLeftParenthesisPosition  = 0
			var intRightParenthesisPosition  = 0
			var intSpacePosition 
			var strChunkContent
			var strUnitContent 
			var strBodyPart 
			var strAttributePart
			var strLeftPartOnLeftParenthesis = ""
			var intChunkCount
			var intWordCount
			var strJSONFormatTree = ""
			while (strSyntaxTree.indexOf("(") != -1) {
				/////////得到当前括号在句法树中的索引位置
				intLeftParenthesisPosition = strSyntaxTree.indexOf("(")
				//得到左括号左边部分
				strLeftPartOnLeftParenthesis = strSyntaxTree.substring(0,intLeftParenthesisPosition)
				//加上左括号左边部分
				strJSONFormatTree += strLeftPartOnLeftParenthesis
				console.log(strJSONFormatTree)
				//////////得到当前左括号对应的右括号在句法树中的索引位置
				intRightParenthesisPosition = this.FromStringTressGetRightParenthesisPosition(intLeftParenthesisPosition,strSyntaxTree)
				//得到组块内容
				strChunkContent = strSyntaxTree.substring(intLeftParenthesisPosition + 1,intRightParenthesisPosition)
				//得到左括号后面的第一个空格位置
				intSpacePosition  = strChunkContent.indexOf(" ")
				//得到左括号引导的单元内容
				strUnitContent = strChunkContent.substring(0,intSpacePosition)
				////////判断是否词节点,若空格后面的是左括号的为组块名称，而非词//////////
				if (strUnitContent.indexOf("W") == 0) {//是词?
				////////词部分单元//////////
					//词编号+1
					intWordCount++
					//得到词的属性部分
					strAttributePart = strUnitContent
					//得到词的块体部分
					strBodyPart = strChunkContent.substring(intSpacePosition + 1,strChunkContent.length)
					//建立新的词单元部分
					strUnitContent =   '"node_content":' + '"' + strBodyPart + '",' + '"node_attribute":' + '"' +  strAttributePart +  '"'
					////按照JSON格式替换相应内容,更新句法树内容
					strSyntaxTree = strSyntaxTree.substring(intRightParenthesisPosition + 2,strSyntaxTree.length)
					//建立左边部分
					strJSONFormatTree += '{' + strUnitContent + '}'
					//不是数组结尾?
					if (strSyntaxTree.substring(0,1) != ']') {
						strJSONFormatTree += ","
					}
				/////////组块部分单元////////////////
				}else if (strUnitContent.indexOf("C") == 0) {//是组块?
					//组块编号+1
					intChunkCount++
					//得到组块的属性部分
					strAttributePart = strUnitContent.substring(0,strUnitContent.indexOf(">>")+2)
					//得到组块的块体部分
					strBodyPart = strUnitContent.substring(strUnitContent.indexOf(">>")+2,strUnitContent.length)
					//建立新的组块单元部分
					strUnitContent =  '"node_content":' + '"' + strBodyPart + '",' + '"node_attribute":' + '"' +  strAttributePart +  '",'
					////剩余部分，按照JSON格式替换相应内容,更新句法树内容
					strSyntaxTree =  strSyntaxTree.substring(intLeftParenthesisPosition + intSpacePosition + 1,intRightParenthesisPosition) + '] }' + strSyntaxTree.substring(intRightParenthesisPosition + 1,strSyntaxTree.length)
					//建立左边部分
					strJSONFormatTree += '{' + strUnitContent + '"children":['
				}else{
					alert("错误！当前的句法树格式引导不是词“W”或者组块“C”!" + "---" + strUnitContent)
					return "(? (A B) )"
				}
			}
			//加上剩余的部分
			strJSONFormatTree += strSyntaxTree
			//数组不是结尾的加分隔符“，”
			var reg;
			reg = new RegExp('} {','g')
            strJSONFormatTree = strJSONFormatTree.replace(reg,'},{');
			return strJSONFormatTree
		},
		//////////得到当前左括号对应的右括号在句法树中的索引位置
		FromStringTressGetRightParenthesisPosition(intLeftParenthsisPosition,strSyntaxTree) {
			var intPointer
			var intLeftParenthesisCount = 0
			var intRightParenthesisCount = 0
			var strUnitContent
			var intTreeLength
			var intRightParenthesisPosition
			//得到句法树字符个数
			intTreeLength = strSyntaxTree.length
			//从指定位置开始
			intPointer = intLeftParenthsisPosition + 1
			while (intPointer <= intTreeLength) {
				//得到一个字符
				strUnitContent = strSyntaxTree.substring(intPointer,intPointer + 1)
				//是左括号?
				if (strUnitContent == "(") {
					//左括号计数
					intLeftParenthesisCount++
				}
				//是右括号?
				if (strUnitContent == ")") {
					//右括号计数
					intRightParenthesisCount++
				}
				//是当前左括号对应的右括号?
				if (intRightParenthesisCount - intLeftParenthesisCount == 1) {
					intRightParenthesisPosition = intPointer
					break
				}
				intPointer++
			}
			//全内容中缺少右括号?
			if (intPointer > intTreeLength) {
				alert("错误！在当前句法树中指定位置" + String(intLeftParenthsisPosition) + "的左括号缺少对应的右括号！" + "--" + strSyntaxTree)
				//建立错误标志
				intRightParenthesisPosition = -1
			}
			return intRightParenthesisPosition
		},
		/////////转换JSON格式句法树到括号型的句法树
		TranJSONSyntaxTreeToNormalFormat(strJSONParsedTree) {
		    var strAttribute;
		    var strContent;
			var strParsedTree = "";
		    var intMarkPosition;
			while(strJSONParsedTree.length != 0) {
				//得到单元标识的位置--"{"
				intMarkPosition  = strJSONParsedTree.indexOf('{')
				if(intMarkPosition  == 0) {
				   //剩余部分
				   strJSONParsedTree = strJSONParsedTree.substring(intMarkPosition + 1,strJSONParsedTree.length)	
                   //建立句法树内容
                   strParsedTree += "("				   
				}
				//得到单元标识的位置 ---属性
				intMarkPosition  = strJSONParsedTree.indexOf('"node_attribute":"')
				if(intMarkPosition  == 0) {
				   strJSONParsedTree = strJSONParsedTree.substring('"node_attribute":"'.length,strJSONParsedTree.length)
				   //得到单元标识的位置
				   intMarkPosition  = strJSONParsedTree.indexOf('"')
				   //得到单元属性部分的内容
				   strAttribute = strJSONParsedTree.substring(0,intMarkPosition)
				   //剩余部分
				   strJSONParsedTree = strJSONParsedTree.substring(intMarkPosition + 1,strJSONParsedTree.length)		   
				   //建立句法树内容
				   if(strAttribute.indexOf('W') == 0){ //是词属性？
				       strParsedTree += strAttribute + " " + strContent;	
                    }
					else { //是组块属性？
					   strParsedTree += strAttribute + strContent;	
					}
				}
				//得到单元标识的位置 ---内容
				intMarkPosition  = strJSONParsedTree.indexOf('"node_content":"')
				if(intMarkPosition  == 0) {
				   strJSONParsedTree = strJSONParsedTree.substring('"node_content":"'.length,strJSONParsedTree.length)
				   //得到单元标识的位置
				   intMarkPosition  = strJSONParsedTree.indexOf('"')
				   //得到单元内容部分的内容
				   strContent = strJSONParsedTree.substring(0,intMarkPosition)
				   //剩余部分
				   strJSONParsedTree = strJSONParsedTree.substring(intMarkPosition + 1,strJSONParsedTree.length)	
                   //建立句法树内容
                   //no operation, wait for attribute data to do	   				   
				}
				//得到单元标识的位置 --子嵌套-开始
				intMarkPosition  = strJSONParsedTree.indexOf('"children":[')
				if(intMarkPosition  == 0) {
				   strJSONParsedTree = strJSONParsedTree.substring('"children":['.length, strJSONParsedTree.length)
				   //得到单元标识的位置
				   intMarkPosition  = strJSONParsedTree.indexOf('{')
				   //剩余部分
				   strJSONParsedTree = strJSONParsedTree.substring(intMarkPosition,strJSONParsedTree.length)	
				   //建立句法树内容
                   strParsedTree += " ";					   
				}
				//得到单元标识的位置 --子嵌套-结束
				intMarkPosition  = strJSONParsedTree.indexOf(']')
				if(intMarkPosition  == 0) {
				   //剩余部分
				   strJSONParsedTree = strJSONParsedTree.substring(intMarkPosition + 1,strJSONParsedTree.length)
				   //建立句法树内容
                   //no operation					   
				}
				//得到单元标识的位置 --"}"
				intMarkPosition  = strJSONParsedTree.indexOf('}')
				if(intMarkPosition  == 0) {
				   //剩余部分
				   strJSONParsedTree = strJSONParsedTree.substring(intMarkPosition + 1,strJSONParsedTree.length)		   
				   //建立句法树内容
				   if(strJSONParsedTree.length != 0) {//不是结尾？
                      strParsedTree += ") ";
				   }
				   else {
				      strParsedTree += ")";
				   }
				}
				//得到单元标识的位置 --","
				intMarkPosition  = strJSONParsedTree.indexOf(',')
				if(intMarkPosition  == 0) {
				   //剩余部分
				   strJSONParsedTree = strJSONParsedTree.substring(intMarkPosition + 1,strJSONParsedTree.length)		   
				   //建立句法树内容
             //      strParsedTree += " ";					   
				}
				//去掉两端空格
				strJSONParsedTree = strJSONParsedTree.trim()
			}
		    return strParsedTree;
		},
				
 		//跳转到用户机器人文档中上一项
		jump_last_ur_number_in_document: function(){
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}		    
		    //判断是否有权限操作
		    if(this.managerAuthority != 1){
				alert("抱歉！无法操作！");
				return
			}
			var ur_num = this.ur_number_in_document;
			//有分割符?
		    if (ur_num.indexOf("/") != -1){
			     //得到纯编号
			     ur_num = ur_num.substring(0,ur_num.indexOf("/"))
			}
			var intNumber = Number(ur_num)
			//指针减一
			if (intNumber > 1){
			   intNumber = intNumber -1
			}else {
			   alert("警告！当前已经是最前的一个用户机器人编号。")
			}
			//更新当前值
			this.ur_number_in_document = String(intNumber)
			//重新调用
			this.jump_now_ur_number_in_document()
		},
		//跳转到用户机器人文档中下一项
		jump_next_ur_number_in_document: function(){
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}		    
		    //判断是否有权限操作
		    if(this.managerAuthority != 1){
				alert("抱歉！无法操作！");
				return
			}
			var ur_num = 0;
			var count = 0;
			//有分割符?
		    if (this.ur_number_in_document.indexOf("/") != -1){
			     //得到纯编号
			     ur_num = this.ur_number_in_document.substring(0,this.ur_number_in_document.indexOf("/"))
				 //得到总数量
				 count = Number(this.ur_number_in_document.substring(this.ur_number_in_document.indexOf("/")+1,this.ur_number_in_document.length))
			}else{
			     ur_num = this.ur_number_in_document
			     count = Number(ur_num) + 1
			}
			var intNumber = Number(ur_num)
			//指针加一
			if (intNumber < count){
			   intNumber = intNumber +1
			}else {
			   alert("警告！当前已经是最大值的一个用户机器人编号。")
			}
			//更新当前值
			this.ur_number_in_document = String(intNumber) + "/" + String(count)
			//重新调用
			this.jump_now_ur_number_in_document()
		},
		
	    //查找用户机器人文档中一个指定用户机器编号的项
		jump_specified_ur_number_in_document: function(){
		
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}			
		    //判断是否有权限操作
		    if(this.managerAuthority != 1){
				alert("抱歉！无法操作！");
				return
			}
			var ur_num = this.ur_number_in_document;
			ur_num  = ur_num.trim()
			if (ur_num.length == 0){//为空内容？
				alert("跳转的编号不能为空！");
				return
			}

			//有分割符?
		    if (ur_num.indexOf("/") != -1){
			     //得到纯编号
			     ur_num = ur_num.substring(0,ur_num.indexOf("/"))
			}
			var intNumber = Number(ur_num)
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_parse_url;
			}else{
				use_IP_url = this.local_parse_url;
			}
			//当前时间
			var dateTimeData = new Date();
		    //选择句库标志
		    var selectMark;
			//建立读写标志
			var bolReadWriteMark = "True"
		   //建立选择用户文档的指定项
			selectMark = "LoadItemInUserDocument"
			//备注内容
			this.comment = "0"
			//用户编号内容
			var test_ur_number = "?"
			//建立库名,区名,用户名，读标志
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + bolReadWriteMark + "/" + this.passWord +  "--" + m_user_host_serial_number + "--" + m_user_host_ip_address + "=" + ur_num + "#" + "0" + "%" + this.comment + "&" + dateTimeData;  
			//句子内容
			var send_data={
			      //发送读取用户编号的参数
                  id:selectMark,
				  option:option_data,//
                  data:test_ur_number //
            };
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){

			  //按编号返回的数据
              var lineData = res.data;				 
			  //得到数据头
              var strDataHead = lineData.substring(0,lineData.indexOf("|||"))
              //剩余数据
              lineData  = lineData.substring(lineData.indexOf("|||") + 3,lineData.length)
			  //得到编号项
			  var ur_item_number = strDataHead.substring(strDataHead.indexOf("user_robot_item_number:") + "user_robot_item_number:".length,strDataHead.length)
			  //显示编号数据
			  this.ur_number_in_document = ur_item_number
			  //显示用户机器人项信息
			  this.parsed_result = lineData;
			},function(res){
			 //显示错误
			 alert(res.status)
			});
		},
	    //跳转到用户机器人文档中当前的一个用户编号的项
		jump_now_ur_number_in_document: function(){
		
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}	
		    //判断是否有权限操作
		    if(this.managerAuthority != 1){
				alert("抱歉！无法操作！");
				return
			}
			var ur_num = this.ur_number_in_document;
			ur_num  = ur_num.trim()
			if (ur_num.length == 0){//为空内容？
				alert("跳转的编号不能为空！");
				return
			}

			//有分割符?
		    if (ur_num.indexOf("/") != -1){
			     //得到纯编号
			     ur_num = ur_num.substring(0,ur_num.indexOf("/"))
			}
			var intNumber = Number(ur_num)
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_parse_url;
			}else{
				use_IP_url = this.local_parse_url;
			}
			//当前时间
			var dateTimeData = new Date();
		    //选择句库标志
		    var selectMark;
			//建立读写标志
			var bolReadWriteMark = "True"
		   //建立选择用户文档的指定项
			selectMark = "LoadItemInUserDocument"
			//备注内容
			this.comment = "0"
			//用户编号内容
			var test_ur_number = "?"
			//建立库名,区名,用户名，读标志
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + bolReadWriteMark + "/" + this.passWord +  "--" + m_user_host_serial_number + "--" + m_user_host_ip_address + "=" + ur_num + "#" + "0" + "%" + this.comment + "&" + dateTimeData;  
			//句子内容
			var send_data={
			      //发送读取用户编号的参数
                  id:selectMark,
				  option:option_data,//
                  data:test_ur_number //
            };
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){

			  //按编号返回的数据
              var lineData = res.data;				 
			  //得到数据头
              var strDataHead = lineData.substring(0,lineData.indexOf("|||"))
              //剩余数据
              lineData  = lineData.substring(lineData.indexOf("|||") + 3,lineData.length)
			  //得到编号项
			  var ur_item_number = strDataHead.substring(strDataHead.indexOf("user_robot_item_number:") + "user_robot_item_number:".length,strDataHead.length)
			  //显示编号数据
			  this.ur_number_in_document = ur_item_number
			  //显示用户机器人项信息
			  this.parsed_result = lineData;
			},function(res){
			 //显示错误
			 alert(res.status)
			});
		},
 		//跳转到资源文档中上一项
		jump_last_resource_number_in_document: function(){
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}		    
		    //判断是否有权限操作
		    if(this.managerAuthority != 1){
				alert("抱歉！无法操作！");
				return
			}
			var resource_num = this.resource_number_in_document;
			//有分割符?
		    if (resource_num.indexOf("/") != -1){
			     //得到纯编号
			     resource_num = resource_num.substring(0,resource_num.indexOf("/"))
			}
			var intNumber = Number(resource_num)
			//指针减一
			if (intNumber > 1){
			   intNumber = intNumber -1
			}else {
			   alert("警告！当前已经是最前的一个资源编号。")
			}
			//更新当前值
			this.resource_number_in_document = String(intNumber)
			//重新调用
			this.jump_now_resource_number_in_document()
		},
		//跳转到资源文档中下一项
		jump_next_resource_number_in_document: function(){
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}		    
		    //判断是否有权限操作
		    if(this.managerAuthority != 1){
				alert("抱歉！无法操作！");
				return
			}
			var resource_num = 0;
			var count = 0;
			//有分割符?
		    if (this.resource_number_in_document.indexOf("/") != -1){
			     //得到纯编号
			     resource_num = this.resource_number_in_document.substring(0,this.resource_number_in_document.indexOf("/"))
				 //得到总数量
				 count = Number(this.resource_number_in_document.substring(this.resource_number_in_document.indexOf("/")+1,this.resource_number_in_document.length))
			}else{
			     resource_num = this.resource_number_in_document
			     count = Number(resource_num) + 1
			}
			var intNumber = Number(resource_num)
			//指针加一
			if (intNumber < count){
			   intNumber = intNumber +1
			}else {
			   alert("警告！当前已经是最大值的一个资源编号。")
			}
			//更新当前值
			this.resource_number_in_document = String(intNumber) + "/" + String(count)
			//重新调用
			this.jump_now_resource_number_in_document()
		},
	    //跳转到资源文档中前一个编号的项
		jump_now_resource_number_in_document: function(){
		
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
		    //判断是否有权限操作
		    if(this.managerAuthority != 1){
				alert("抱歉！无法操作！");
				return
			}
            //得到资源提供商名称			
			var resource_provider_name = this.input_sentence;
            //建立资源码指针编号			
			var resource_num = this.resource_number_in_document;
			resource_num  = resource_num.trim()
			if (resource_num.length == 0){//为空内容？
				alert("跳转的编号不能为空！");
				return
			}

			//有分割符?
		    if (resource_num.indexOf("/") != -1){
			     //得到纯编号
			     resource_num = resource_num.substring(0,resource_num.indexOf("/"))
			}
			var intNumber = Number(resource_num)
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_parse_url;
			}else{
				use_IP_url = this.local_parse_url;
			}
			//当前时间
			var dateTimeData = new Date();
		    //选择句库标志
		    var selectMark;
			//建立读写标志
			var bolReadWriteMark = "True"
		   //建立选择用户文档的指定项
			selectMark = "LoadItemInResourceDocument"
			//备注内容--提供商名称
			this.comment = resource_provider_name
			//用户编号内容
			var test_resouce_number = "?"
			//建立库名,区名,用户名，读标志
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + bolReadWriteMark + "/" + this.passWord +  "--" + m_user_host_serial_number + "--" + m_user_host_ip_address + "=" + resource_num + "#" + "0" + "%" + this.comment + "&" + dateTimeData;  
			//句子内容
			var send_data={
			      //发送读取用户编号的参数
                  id:selectMark,
				  option:option_data,//
                  data:test_resouce_number //
            };
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){
			
              //清空显示
			  this.faq_question = ""
			  this.faq_answer = ""
			  this.faq_action = ""
			  //按编号返回的数据
              var lineData = res.data;				 
			  //得到数据头
              var strDataHead = lineData.substring(0,lineData.indexOf("|||"))
              //剩余数据
              lineData  = lineData.substring(lineData.indexOf("|||") + 3,lineData.length)
			  //得到编号项
			  var resource_item_number = strDataHead.substring(strDataHead.indexOf("resource_code_item_number:") + "resource_code_item_number:".length,strDataHead.length)
			  //更新显示编号数据 --使用来自真实的总数值
			  this.resource_number_in_document = resource_num + "/" + resource_item_number.substring(resource_item_number.indexOf("/")+1,resource_item_number.length)
			  //显示用户机器人项信息
			  this.parsed_result = lineData;
			},function(res){
			 //显示错误
			 alert(res.status)
			});
			//返回资源编号项信息
			return resource_item_number
		},
		
		//管理机器人用户（设置用户使用期限）
		admin_user_using_time: function(){	

		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
		    //判断是否有权限操作
		    if(this.managerAuthority != 1){
				alert("抱歉！无法操作！");
				return
			}
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_parse_url;
			}else{
				use_IP_url = this.local_parse_url;
			}
			//当前时间
			var dateTimeData = new Date();
		    var selectMark;
		    //建立修改用户使用期限标志
			selectMark = "ChangeUserExpiredTime"
			//备注内容
			this.comment = "0"
		    var data = this.input_sentence;
			if (data.indexOf("|||") == -1){
			  alert("查询信息格式错误：" + "请在输入句子窗口，用“【11位手机号】|||【机器人序列号】|||【使用期限】”这样格式输入！如“139xxxxxxxx|||P1G1|||10天”")
              return			  
			}
            data = data.substring(data.indexOf("|||") +3,data.length)
			if (data.indexOf("|||") == -1){
			  alert("查询信息格式错误：" + "请在输入句子窗口，用“【11位手机号】|||【机器人序列号】|||【使用期限】”这样格式输入！如“139xxxxxxxx|||P1G1|||10天”")
              return			  
			}
            data = data.substring(data.indexOf("|||") +3,data.length)
			var user_using_time = data
			if (user_using_time.indexOf("天") == -1 && user_using_time.indexOf("年") == -1){
			  alert("设置用户使用期限的格式错误：" + "请在输入句子窗口，用“X天或X年”这样格式输入！如“15天或者1年”")
              return			  
			}
			
			var time_data = "0"
			if(user_using_time.indexOf("天") != -1){
			  time_data = user_using_time.substring(0,user_using_time.indexOf("天"));
			  if(this.isNumber(time_data) !=  true){//是有效数字？
			     alert("使用期限的格式错误：" + "量词“天”之前不是数字！" )
				 return
			  }
			}
			if(user_using_time.indexOf("年") != -1){
			  time_data = user_using_time.substring(0,user_using_time.indexOf("年"));
			  if(this.isNumber(time_data) !=  true){//是有效数字？
			     alert("使用期限的格式错误：" + "量词“年”之前不是数字！" )
				 return
			  }
			}
			
			this.comment = "0"
			//建立库名,区名,用户名，
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + "true"  + "/" + this.passWord +  "--" + m_user_host_serial_number + "--" + m_user_host_ip_address + "=" + this.candiate_template_number + "#" + this.sub_template_number + "%" + this.comment + "&" + dateTimeData;  
			var send_data={
			      //发送用户机器人编号内容
                  id:selectMark,
				  option:option_data,//建立选项数据
                  data:this.input_sentence //用户使用期限数据
            };
			alert("设置用户使用期限:" + "\r\n" + this.input_sentence);
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){
				//返回管理用户使用期限的结果
				alert("用户使用期限管理--" + res.data);
			},function(res){
			 //显示错误
			 alert(res.status)
			});
		},
		//得到用户的使用期限
		get_user_expired_time: function(){	
  	        //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
		    //判断是否有权限操作
		    if(this.managerAuthority != 1){
				alert("抱歉！无法操作！");
				return
			}
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_parse_url;
			}else{
				use_IP_url = this.local_parse_url;
			}
			//当前时间
			var dateTimeData = new Date();
		    //选择句库标志
		    var selectMark;
			var strParsedResult;
			var strUnderstoodResult;
		   //建立得到用户过期时间的标志
			selectMark = "GetUserExpiredTime"
			//备注内容
			this.comment = "0"
			//建立库名,区名,用户名，
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + "true"  + "/" + this.passWord +  "--" + m_user_host_serial_number + "--" + m_user_host_ip_address + "=" + this.candiate_template_number + "#" + this.sub_template_number + "%" + this.comment + "&" + dateTimeData;  
			//获取用户机器人编号内容
		    var test_ur_number = this.input_sentence;
			if (test_ur_number.indexOf("|||") == -1){
			  alert("查询信息格式错误：" + "请在输入句子窗口，用“【11位手机号】|||【机器人序列号】”这样格式输入！如“139xxxxxxxx|||P1G1”")
              return			  
			}
	
			var robot_number = test_ur_number.substring(test_ur_number.indexOf("|||") +3,test_ur_number.length)
			if (robot_number.indexOf("|||") != -1){//还有“|||”分割符号？--可能是续时间信息，要去掉
			   robot_number = robot_number.substring(0,robot_number.indexOf("|||"))
			   //建立新的输入值
			   test_ur_number = test_ur_number.substring(0,test_ur_number.indexOf("|||")) + "|||" + robot_number
			}
			var send_data={
			      //发送测试句子
                  id:selectMark,
				  option:option_data,//建立选项数据
                  data:test_ur_number //用户机器人编号内容
            };
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){

			//用户使用期限数据
			if (res.data == "")//为空?
			{
				//清空结果文件
				this.parsed_result = ""
			    return
			}
		    console.log(res.data)
		    var lineData = res.data
		    //得到数据头
		    var strDataHead = ""
			if(lineData.indexOf("|||") != -1){
				strDataHead = lineData.substring(0,lineData.indexOf("|||"))
				//剩余数据
				lineData  = lineData.substring(lineData.indexOf("|||") + 3,lineData.length)
			}
			

			////////显示使用期限信息///////
 			//得到使用状态
			var use_status = lineData.substring(0,lineData.indexOf("BankName="))
			//得到使用期限
			var authorized_time = ""
			if(lineData.indexOf("AuthorizedTime=") != -1){
			  if(lineData.indexOf("ResourceParameters=[") != -1){
			     authorized_time = lineData.substring(lineData.indexOf("AuthorizedTime=") + "AuthorizedTime=".length,lineData.indexOf("ResourceParameters=["))
			  }
			  else{
			     authorized_time = lineData.substring(lineData.indexOf("AuthorizedTime=") + "AuthorizedTime=".length,lineData.length)
			  }
		      authorized_time = authorized_time.substring(0,authorized_time.indexOf(","))
            }else{
			  authorized_time = "错误，数据中没有使用期限信息。"
            }
			
			//弹出显示
			alert(use_status + ",使用期限：" + authorized_time)

			//显示用户使用资源信息
			lineData = lineData.substring(lineData.indexOf("BankName="),lineData.length)
			var strContent = this.ShowResourceContentWithLineFormat(lineData)
			this.parsed_result = strContent;

		  });
        },
		
		//显示资源按照换行格式
		ShowResourceContentWithLineFormat: function(lineData){
			//调整显示格式，每个资源单独一行，便于查看和更新参数
			var strContent = ""
			if(lineData.indexOf("ResourceParameters=[") != -1){//有资源头标识？
			   strContent += lineData.substring(0,lineData.indexOf("ResourceParameters=["))
			   strContent += "\r\n" + "ResourceParameters=["  //资源头标识 --单独一行
			   lineData = lineData.substring(lineData.indexOf("ResourceParameters=[") + "ResourceParameters=[".length ,lineData.length) //余下内容
			}
			else{
			   alert("错误，数据中没有资源头标识”ResourceParameters=[“")
			   return ""
			}
			var oneLine = ""
			while(lineData.indexOf("},") != -1){//有多个主资源？
			   oneLine = lineData.substring(0,lineData.indexOf("},"))
			   strContent += "\r\n" + oneLine + "},"  //每个主资源单独一行
			   lineData = lineData.substring(lineData.indexOf("},") + "},".length, lineData.length) //余下内容
			}
			if(lineData.indexOf("}]") != -1){//有资源尾标识？
			   oneLine = lineData.substring(0,lineData.indexOf("}"))
			   strContent += "\r\n" + oneLine + "}"  //最后主资源单独一行
			   lineData = lineData.substring(lineData.indexOf("}") + "}".length ,lineData.length) //余下内容
			   strContent += lineData   //最后结尾标识单独一行
			}
			else{
			   alert("错误，数据中没有资源尾标识”}]“")
			   return ""
			}						
            return strContent
		},

        //得到资源码总数
        GetTotalOfResourceCode: function(){
		    var strTotalOfResourceCode = this.resource_number_in_document
			if(strTotalOfResourceCode.indexOf("/") == -1){
			   //请先在输入当前总数值
			   alert("请先保证当前资源编号框内有当前的总数值，或者按一下”go“按钮！")
			   return
			}
		    //得到当前的资源码总数
 			strTotalOfResourceCode = strTotalOfResourceCode.substring(strTotalOfResourceCode.indexOf("/") + 1,strTotalOfResourceCode.length)
			return strTotalOfResourceCode
		},
		
		//判断字符串是否为数字？
		isNumber: function(val){
		  var regPos = /^\d+(\.\d+)?$/; //非负浮点数
		  var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
		  if(regPos.test(val) || regNeg.test(val)) {
			  return true;
		  } else {
			  return false;
		  }
		},

		//发送用户的接受消息
		send_message: function(){	

		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}

			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_parse_url;
			}else{
				use_IP_url = this.local_parse_url;
			}
			//当前时间
			var dateTimeData = new Date();
		    var selectMark;
		    //建立修改用户使用期限标志
			selectMark = "ChangeUserMessage"
			//备注内容
			this.comment = "0"
		    var data = this.input_sentence;
			if (data.indexOf("|||") == -1){
			  alert("查询信息格式错误：" + "请在输入句子窗口，用“【11位手机号】|||【机器人序列号】|||【用户消息】”这样格式输入！如“139xxxxxxxx|||P1G1|||这是一个消息”")
              return			  
			}
            data = data.substring(data.indexOf("|||") +3,data.length)
			if (data.indexOf("|||") == -1){
			  alert("查询信息格式错误：" + "请在输入句子窗口，用“【11位手机号】|||【机器人序列号】|||【用户消息】”这样格式输入！如“139xxxxxxxx|||P1G1|||这是一个消息”")
              return			  
			}
            data = data.substring(data.indexOf("|||") +3,data.length)
			var user_message = data
			

			//建立库名,区名,用户名，
			var m_user_host_serial_number = "PC-Platform";
			var m_user_host_ip_address = "127.0.0.1";
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + "true"  + "/" + this.passWord +  "--" + m_user_host_serial_number + "--" + m_user_host_ip_address + "=" + this.candiate_template_number + "#" + this.sub_template_number + "%" + this.comment + "&" + dateTimeData;  
			var send_data={
			      //发送用户机器人编号内容
                  id:selectMark,
				  option:option_data,//建立选项数据
                  data:this.input_sentence //数据
            };
			alert("设置用户的接受消息:" + "\r\n" + this.input_sentence);
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){
				//发送用户的接受消息的结果
				alert("用户的接受消息--" + res.data);
			},function(res){
			 //显示错误
			 alert(res.status)
			});
		},
		//发送激活状态数据
		send_active_code_status: function(UserHostSerialNumber,strActiveCodeStatus,strBizCode,strValidDays){	
		    //判断是否登录成功
		    if(this.login_mark != true){
				alert("请先登录成功再操作！");
				return
			}
			//使用的IP地址接口
			var use_IP_url;
			if (this.check_romote_port == true)	{
				use_IP_url = this.romote_parse_url;
			}else{
				use_IP_url = this.local_parse_url;
			}
			//当前时间
			var dateTimeData = new Date();
		    var selectMark;
		    //建立语句命令，设置激活码状态
			selectMark = "ChangeUserActiveCodeStatus"
			//备注内容
			this.comment = "0"
			//建立库名,区名,用户名，
			var option_data = this.bank_name + ":" + this.section_name + "@" + this.user_name + "$" + "true" + "/" + "SetUserIPDuration" + "--0--0.0.0.0" + "=" + "0" + "#" + "0" + "%" + this.comment + "&" + dateTimeData;  
			//建立数据内容 -- 用户机器编号 和 写入的激活状态
			var data_content = UserHostSerialNumber + "|||" + strActiveCodeStatus + "|||" + strBizCode + "|||" + strValidDays
			var send_data={
			      //发送数据
                  id:selectMark,
				  option:option_data,//建立选项数据
                  data: data_content//数据内容
            };
		//	alert("id:" + selectMark + "; " + "option:" + option_data + ";" + "\r\n" + "data:" + data_content);
			var transFormatData=function(send_data) {
			  return $.param(send_data);
			};
			var content={
			  headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},   
			  transformRequest: transFormatData
			};
			this.$http.post(use_IP_url,send_data,{emulateJSON:true})
			.then(function(res){
			   //返回的结果
			   alert("建立激活码状态：" + res.data);
			},function(res){
			   //显示错误
			   alert(res.status)
			});
		},

        //生成12位激活码
		generateActivationCode: function(biz_code,using_time,machine_code){

			for(let i=0;i<32;i++) revBox[box[i]] = i;
			// ========== 测试 ==========
			//const m13 = "7SK38D8Z4BF9U";
			//const key = this.createActiveKey("A6", 365, m13);
			
			// ========== 运行 ==========
			if(machine_code.length != 13)	{
			   alert("错误，机器码必须是13位,当前的机器编号--" + machine_code)
			   return
			}
			if(biz_code.length != 2)	{
			   alert("错误，业务码必须是2位,当前的业务码--" + biz_code)
			   return
			}
			//判断业务码是否英文字母大写和数字
			var reg = /^[A-Z0-9]+$/;
            if (reg.test(biz_code) == false){
			   alert("错误，业务码必须是英文大写,当前的业务码--" + biz_code)
			   return
			}
			if(biz_code.indexOf("0") != -1||biz_code.indexOf("1") != -1 ||biz_code.indexOf("O") != -1||biz_code.indexOf("I") != -1)	{
			   alert("错误，业务码不允许使用数字“0“、”1”或使用大写英文“O“、”I”。,当前的业务码--" + biz_code)
			   return
			}
			if(using_time.length < 1 || using_time.length > 3 ||Number.isNaN(using_time)== true)	{
			   alert("错误，使用天数必须是1-999的数字,当前的使用天数--" + using_time)
			   return
			}
			const key = this.createActiveKey(biz_code, using_time,machine_code);

			console.log("12位激活码：",key);
			//直接显示激活码
			this.active_code = key
			//带分隔符显示激活码
			this.active_code = key.slice(0,4)+ "-" + key.slice(4,8)+ "-" + key.slice(8,12)
		//	alert(this.active_code)

			// 关键：直接解析出业务码、天数
			const info = this.parseActiveKey(key);
			console.log("解析结果 业务码：",info.biz," 天数：",info.days);
			console.log("设备校验：",this.checkActiveKey(key,machine_code));
			return key
		},
		
		// 天数0~1023 → 2位safe32
		numTo2Bit: function (n){
			const h = Math.floor(n / 32);
			const l = n % 32;
			return safe32[h] + safe32[l];
		},
		
		// 2位safe32 → 天数
		twoBitToNum : function (s){
			const h = safe32.indexOf(s[0]);
			const l = safe32.indexOf(s[1]);
			return h * 32 + l;
		},

		// 加密：业务+天数 前4位隐私加密
		encodeBizDay: function (biz,days){
			const dayStr = this.numTo2Bit(days);
			const raw = biz + dayStr;
			let enc = "";
			for(let c of raw){
				let idx = safe32.indexOf(c);
				enc += safe32[box[idx]];
			}
			return enc;
		},
		// 解密：从4位密文 取出 业务码、天数
		decodeBizDay: function (enc4){
			let raw = "";
			for(let c of enc4){
				let idx = safe32.indexOf(c);
				raw += safe32[revBox[idx]];
			}
			const biz = raw.slice(0,2);
			const days = this.twoBitToNum(raw.slice(2,4));
			return {biz,days};
		},

		// HMAC 校验摘要
		calcHmac: function (machine13,biz,days){
			const src = salt + machine13 + biz + days;
			return crypto.createHmac("sha256",secret).update(src).digest("hex").toUpperCase();
		},

		// 生成12位激活码
		createActiveKey: function (biz,days,machine13){
			const part1 = this.encodeBizDay(biz,days);  // 4位 加密业务+天数
			const hmac = this.calcHmac(machine13,biz,days);
			const part2 = hmac.slice(0,8);         // 8位 校验密文
			return part1 + part2;
		},

		// 解析激活码：拿到业务码、天数
		parseActiveKey: function (key12){
			if(key12.length !== 12) throw new Error("长度错误");
			const part4 = key12.slice(0,4);
			return this.decodeBizDay(part4);
		},

		// 设备校验
		checkActiveKey: function (key12,machine13){
			try{
				const {biz,days} = this.parseActiveKey(key12);
				const hmac = this.calcHmac(machine13,biz,days);
				return hmac.slice(0,8) === key12.slice(4);
			}catch(e){
				return false;
			}
		},

		//点击Logo连续五次的响应
		handleLogoClick: function() {
		  if (this.showInput) return
		  this.clickCount++

		  if (this.clickCount >= 5) {
			this.showInput = true
			this.showSecretText = true
			this.clickCount = 0
			clearTimeout(this.timer)
		//	alert("000")
			//建立管理权限许可
			this.managerAuthority = 1
			
			return
		  }

		  clearTimeout(this.timer)
		  this.timer = setTimeout(() => {
			this.clickCount = 0
		  }, 2000)
		},
    }

}
</script>

<style>
.btn_speech_off {
      width: 100px;
      height: 30px;
      background: orange;
}
.btn_speech_on {
  width: 100px;
  height: 30px;
  background-color: yellowgreen;
}#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 15px;
}
#app .name{font-weight:700;}
.foot {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background: #333;
    padding: 10px;
    overflow: hidden;
    color: #999;
    font-size: 14px;
    text-align: center;
}
.foot a{color:#fff;margin:0 .5em}

</style>



// WEBPACK FOOTER //
// src/App.vue